import { Send, TroubleshootSharp } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import axios from "axios";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { debounce, result, set, truncate } from "lodash";
import moment from "moment";
import * as React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { Rating } from "react-simple-star-rating";
// import Rating from "@mui/material/Rating";
import { default as MuiRating } from "@mui/material/Rating";

// React Simple Star Rating
import { Rating as SimpleRating } from "react-simple-star-rating";
import { RootState } from "../../Store";
import { strings } from "../../Store/Localization";
import CustomButton from "../../UiComponent/CustomButton";
import DraggableDialog from "../../UiComponent/DraggableDialog";
import InputField from "../../UiComponent/TextFeild";
import Toast from "../../UiComponent/Toast/Toast";
import {
  HoverStar,
  ImageSendIcon,
  MessageSendIcon,
  RefrestIcon,
  SmallStarIcon,
  SmallStarIconGray,
  StarIcon,
  StarIconGray,
  VerifyIcon,
} from "../../assets/images/FrankIcons";
import { BASE_URL } from "../../services/HttpProvider";
import apiServices from "../../services/RequestHandler";
import { decrypt } from "../../utils/Encrypt";
import { getDataFromLocalStorage } from "../../utils/LocalStore.util";
import {
  color_theme,
  defaultLabelColors,
  no_image_url,
  no_profile_image,
  spacing,
  stripePromise,
} from "../../utils/constants";
import {
  currencyFormat,
  formatPhoneNumber,
  handleLocalize,
  numberFormatWithoutCurrency,
  numberFormatWithoutCurrencyFixedOne,
  toBase64,
} from "../../utils/helper";
import { firestoreDB } from "../../utils/notificationListner";
import { FrankDivider } from "../MarketPlace/Checkout";
import StripeCheckout from "../MyAnnounces/StripeCheckout";
import OTPInput from "react-otp-input";
import { useMediaQuery, useTheme } from "@mui/system";

export function MessageComponent({ item, user, chatMessages, index }: any) {
  const options = {
    appearance: {
      theme: "flat",
      variables: {
        fontFamily: "Montserrat, sans-serif",
        fontWeightNormal: "400",
        fontWeightMedium: "500",
      },
    },
  };
  const theme = useTheme();

  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const status = item?.sender_id !== `${user?.id ?? ""}`;
  let prev_msg_date =
    index === 0
      ? chatMessages?.[index]?.created_at
      : chatMessages?.[index - 1]?.created_at;
  const prev_msg_date_moment = moment(prev_msg_date);
  const renderDateHeader = React.useMemo(() => {
    return (
      <div
        style={{ placeContent: "center", margin: "10px 0px", display: "flex" }}
      >
        <span
          style={{
            color: "gray",
            fontSize: 12,
            fontFamily: "montserrat-Regular",
          }}
        >
          {prev_msg_date_moment.format("MMM D, YYYY")}
        </span>
      </div>
    );
  }, [prev_msg_date_moment]);

  // eslint-disable-next-line
  if (item?.file_type === "location" && typeof item?.location === "string") {
    // loc = JSON.parse(item?.location);
  } else {
    // loc = item?.location;
  }

  return (
    <div key={`ITEM_MESSAGE_01_${index + 1}`}>
      {item?.is_negotiate || item?.order_details
        ? null
        : index === 0
        ? renderDateHeader
        : // eslint-disable-next-line
        prev_msg_date_moment.format("YYYY-MM-DD") ===
          prev_msg_date_moment.format("YYYY-MM-DD")
        ? null
        : renderDateHeader}
      <div
        style={{
          borderRadius: 10,
          alignItems:
            item?.is_negotiate || item?.order_details
              ? "center"
              : status
              ? "end"
              : "flex-end",
          justifyContent:
            item?.is_negotiate || item?.order_details
              ? "center"
              : status
              ? "flex-start"
              : "flex-end",
          marginBottom: 10,
          display: item?.is_negotiate || item?.order_details ? "none" : "flex",
        }}
      >
        <div
          style={{
            flexDirection: "row",
            alignItems: "center",
            borderRadius: 10,
            display: "flex",
            justifyContent:
              item?.is_negotiate || item?.order_details
                ? "center"
                : status
                ? "flex-start"
                : "flex-end",
            maxWidth: "75%",
          }}
        >
          <div
            style={{
              overflowWrap: "anywhere",
              fontFamily: "montserrat-Regular",
              padding: "16px",
              margin: "0px 12px",
              // paddingBottom: "7px",

              position: "relative",
              backgroundColor: item?.order_details
                ? color_theme.card_background
                : item?.is_negotiate
                ? color_theme.card_background
                : status
                ? screen_1024
                  ? color_theme.main_orange
                  : "#F4F3F6"
                : screen_1024
                ? "lightgrey"
                : "#DCDBFB",
              borderRadius: screen_1024 ? 20 : "12px",
            }}
          >
            {item?.order_details ||
            item?.is_negotiate ? null : item?.audio_url ? null : item?.file_url ? (
              <div>
                {item?.file_type === "doc" ? (
                  <div
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <h1>DOC_ICON</h1>
                    <span
                      style={{
                        color: status ? color_theme.white : color_theme.black,
                        fontSize: 12,
                        fontFamily: "Epilogue",
                        lineHeight: 16,
                        paddingLeft: 10,
                      }}
                    >
                      {item?.file_name ?? "Document"}{" "}
                    </span>
                  </div>
                ) : (
                  <img
                    style={{
                      height: 200,
                      width: 200,
                      objectFit: "contain",
                    }}
                    src={item?.file_url}
                    alt="imge"
                  />
                )}
              </div>
            ) : item?.message ? (
              <span
                style={{
                  color: status
                    ? screen_1024
                      ? color_theme.white
                      : "#000"
                    : color_theme.black,
                  fontSize: 16,
                  fontFamily: "montserrat-Regular",
                }}
              >
                {item?.message ?? ""}
              </span>
            ) : item?.file_type === "location" ? (
              <div
                style={{
                  height: 150,
                  width: "100%",
                  background: "red",
                }}
                // onPress={async () => {
                //   const lat = loc.coordinates[0];
                //   const lng = loc.coordinates[1];
                //   const scheme = Platform.select({
                //     ios: `maps://${loc.coordinates[0]},${loc.coordinates[1]}?q=`,
                //     android: `geo:${loc.coordinates[0]},${loc.coordinates[1]}?q=`,
                //   });
                //   const latLng = `${lat},${lng}`;
                //   const label = `${item?.sender_name}'s location`;
                //   const url = Platform.select({
                //     ios: `${scheme}${label}@${latLng}`,
                //     android: `${scheme}${latLng}(${label})`,
                //   });
                //   Linking.openURL(url as string);
                // }}
              >
                {/* <MapView
                  scrollEnabled={true}
                  rotateEnabled={true}
                  zoomEnabled={true}
                  provider={PROVIDER_GOOGLE}
                  style={StyleSheet.absoluteFillObject}
                  region={{
                    latitude: loc.coordinates[0] ?? 48.85806249896775,
                    longitude: loc.coordinates[1] ?? 2.3535707423777468,
                    latitudeDelta: LATITUDE_DELTA,
                    longitudeDelta: LONGITUDE_DELTA,
                  }}
                >
                  <Marker
                    coordinate={{
                      latitude: loc?.coordinates[0] ?? 48.85806249896775,
                      longitude: loc?.coordinates[1] ?? 2.3535707423777468,
                    }}
                  >
                    <Image
                      source={MapMarker}
                      style={{
                        height: 20,
                        width: 20,
                        resizeMode: "contain",
                      }}
                    />
                  </Marker>
                </MapView> */}
              </div>
            ) : null}
          </div>
        </div>
        {!item?.is_negotiate && !item?.order_details && (
          <div
            style={{
              justifyContent: "flex-end",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            {/* <span
              style={{
                marginLeft: 5,
                paddingRight: 5,
                color: color_theme.black,
                fontSize: 12,
                fontFamily: "montserrat-Regular",
                marginTop: 2,
              }}
            >
              {moment(
                item?.created_at
                  ? `${item?.created_at}`.endsWith("Z")
                    ? item?.created_at
                    : item?.created_at + "Z"
                  : new Date()
              ).format("HH:mm")}
            </span> */}
          </div>
        )}
      </div>
    </div>
  );
}

interface AnnouncementChatProps {
  // Define the props interface based on the expected props
  // Add specific prop types if needed, for now, 'any' is used as a placeholder.
  announcement_details: any;
  chat_details: any;
  // [key: string]: any;
}

const AnnouncementChat: React.FC<AnnouncementChatProps> = (props) => {
  const { announcement_details } = props;
  
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [currentLocation, setCurrentLocation] = React.useState<any>();
  const [isTyping, setTypingUsers] = React.useState<boolean>(false);
  const [otp, setOtp] = React.useState("");
  const scrollRef = React.useRef<any>();
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      recording: "stop",
      latitude: 48.85806249896775,
      longitude: 2.3535707423777468,
      loading_screen: true,
      chat_details: props?.chat_details?.[0],
      doNotShowPromo: true,
    }
  );

  const handleChangeForNego = (event: any) => {
    let { value } = event.target;

    value = value?.replace(".", ",");

    if (/^\d*(,\d{0,2})?$/.test(value)) {
      setState({ new_nego_price: value });
    }
  };


  
  const [chatMessages, setChatMessages] = React.useState<any>([]);
  const selector = useSelector((state: RootState) => state.mainApp);
  const [message, setMessage] = React.useState("");
  // eslint-disable-next-line
  const [user, setUser] = React.useState(getDataFromLocalStorage("user"));
  const [hover, setHover] = React.useState(-1);

  const typingStatusRef = doc(
    firestoreDB,
    "typing_status",
    `${announcement_details?.receiver_id ?? ""}_${user?.id ?? ""}`
  );

  const updateTypingStatus = async (isTyping: any) => {
    try {
      if (isTyping) {
        await setDoc(
          typingStatusRef,
          {
            chatId: `${announcement_details?.receiver_id ?? ""}_${
              user?.id ?? ""
            }`,
            user_id: `${user?.id}`,
            isTyping: true,
            resource_id: `${announcement_details?.id ?? ""}`,
          },
          { merge: true }
        );
      } else {
        await updateDoc(typingStatusRef, { isTyping: false });
      }
    } catch (error) {
      console.error("Error updating typing status:", error);
    }
  };

  const debouncedStopTyping = debounce(() => {
    updateTypingStatus(false);
  }, 3000); // Stop typing after 3 seconds of inactivity

  React.useEffect(() => {
    // Cleanup on component unmount
    return () => {
      debouncedStopTyping.cancel(); // Cancel any pending debounce calls
      updateTypingStatus(false); // Ensure typing status is cleared
    };
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    getMessages();
    handleGetUserCurrentLocation();
    // eslint-disable-next-line
  }, [JSON.stringify(announcement_details)]);

  React.useEffect(() => {
    const messagesRef = collection(firestoreDB, "chat_negotiations");

    const q1 = query(
      messagesRef,
      where("sender_id", "in", [
        `${user?.id}`,
        `${announcement_details?.receiver_id}`,
      ]),
      where("receiver_id", "in", [
        `${user?.id}`,
        `${announcement_details?.receiver_id}`,
      ]),
      where("order_id", "==", `${announcement_details?.id}`)
    );

    const unsubscribe1 = onSnapshot(q1, (snapshot) => {
      let newMessages = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      newMessages = newMessages.sort((a: any, b: any) =>
        new Date(a.created_at).getTime() < new Date(b.created_at).getTime()
          ? -1
          : 1
      );

      setChatMessages(newMessages);
      getMessages();
    });

    const typingQuery = query(
      collection(firestoreDB, "typing_status"),
      where("chatId", "in", [
        `${announcement_details?.receiver_id ?? ""}_${user?.id ?? ""}`,
        `${user?.id ?? ""}_${announcement_details?.receiver_id ?? ""}`,
      ]),
      where("resource_id", "==", `${announcement_details?.id}`),
      where("user_id", "!=", `${user?.id}`),
      where("isTyping", "==", true)
    );

    const unsubscribe = onSnapshot(typingQuery, (snapshot) => {
      const users = snapshot.docs.map((doc) => doc.data());

      if (users.length > 0) {
        setTypingUsers(true);
      } else {
        setTypingUsers(false);
      }
    });

    return () => {
      unsubscribe();
      unsubscribe1();
    };
    // eslint-disable-next-line
  }, [announcement_details]);

  React.useEffect(() => {
    if (chatMessages) {
      const scrollIntoView = () => {
        if (scrollRef?.current) {
          scrollRef.current.scrollTop = scrollRef?.current?.scrollHeight + 100;
        }
      };
      return scrollIntoView;
    }
    // eslint-disable-next-line
  }, [chatMessages]);

  React.useEffect(() => {
    if (
      state?.product_details?.ship_status_level === 2 &&
      state?.product_details?.payment_status !== "Paid"
    ) {
      initPayment();
    }
    // eslint-disable-next-line
  }, [JSON.stringify(state.product_details)]);

  //   React.useEffect(() => {
  //  if (
  //       props?.chat_details?.ship_status_level === 2 &&
  //       props?.chat_details?.payment_status !== "Paid"
  //     ) {
  //       initPayment();
  //     }    // eslint-disable-next-line
  //   }, [props?.chat_details?.ship_status]);

  const initPayment = async () => {
    try {
      let total_amt = 0;

      if (props?.chat_details?.handling) {
        total_amt =
          props?.chat_details?.order_amount_detail?.sub_total > 0
            ? Number(props?.chat_details?.order_amount_detail?.sub_total ?? 0)
            : Number(
                props?.chat_details?.agree_ship_price ??
                  props?.chat_details?.ship_price ??
                  0
              ) +
              Number(
                (Number(
                  props?.chat_details?.agree_ship_price ??
                    props?.chat_details?.ship_price ??
                    0
                ) /
                  100) *
                  Number(
                    props?.chat_details?.handling?.handling_charges_percent
                  )
              ) +
              Number(props?.chat_details?.service_charges ?? 0);
      } else {
        total_amt =
          props?.chat_details?.order_amount_detail?.sub_total > 0
            ? Number(props?.chat_details?.order_amount_detail?.sub_total ?? 0) +
              Number(props?.chat_details?.service_charges ?? 0)
            : Number(
                props?.chat_details?.agree_ship_price ??
                  props?.chat_details?.ship_price ??
                  0
              ) + Number(props?.chat_details?.service_charges ?? 0);
      }

      const response = await apiServices.postFromApi(
        "stripe/payment-sheet-with-card",
        {
          ship_id: Number(props?.chat_details?.id),
        },
        ""
      );
      let decryptData = JSON.parse(decrypt(response.pi_key));
      if (typeof decryptData === "string") {
        decryptData = JSON.parse(decryptData);
      }
      const { paymentIntent } = decryptData ?? {};

      const options = {
        theme: "stripe",

        clientSecret: paymentIntent,
        appearance: {
          theme: "stripe",
          // variables: {
          //   fontFamily: '"montserrat-Regular", sans-serif',
          // },
          // rules: {
          //   ".Label": {
          //     fontFamily: '"montserrat-Regular", sans-serif',
          //     fontSize: "14px", // Adjust the size as needed
          //     color: "#000000", // Change the color if needed
          //   },
          // },
        },
      };
      setState({ options, enable_stripe: true, total_amt });
    } catch (error) {
      console.log(error);
    }
  };


// React.useEffect(() => {
//   console.log("announcement_details",announcement_details)
//   console.log("user",user)
// }, [])


  const getMessages = async () => {
    const item = announcement_details;
    try {
      // let obj: any = {
      //   receiver_id: `${item?.receiver_id}`,
      //   ship_id: Number(item?.id),
      // };

      // const messagesRef = collection(firestoreDB, "chat_negotiations");
      // const q = query(
      //   messagesRef,
      //   where("sender", "in", [`${user?.id}`, `${item?.receiver_id}`]), // Sender is either user
      //   where("receiver", "in", [`${user?.id}`, `${item?.receiver_id}`]), // Receiver is either user
      //   orderBy("timestamp", "asc") // Sort by time
      // );

      // const resp = await apiServices.postFromApi(
      //   "/chat/get-messages-by-user-by-announce",
      //   obj,
      //   ""
      // );



      if (item?.id) {
        const resp2 = await apiServices.postFromApi(
          `c2c-shipments/details`,
          {
            id: Number(item?.id),
            customer_id: Number(item?.customer_id),
          },
          ""
        );

        // Step 1: Find all parent_ids of accepted negotiations
        const acceptedParentIds = new Set(
          resp2?.data?.negotiations
            .filter(
              (item: any) =>
                item.is_accepted === true && item.parent_id !== null
            )
            .map((item: any) => item.parent_id)
        );
        // Step 2: Filter out items whose `id` is in acceptedParentIds
        const filteredNegotiations = resp2?.data?.negotiations.filter(
          (item: any) => !acceptedParentIds.has(item.id)
        );
        let details = {
          ...resp2?.data,
          negotiations: filteredNegotiations,
        };

        setState({
          product_details: details, //resp2?.data ?? {},
          loading_screen: false,
          user_feedback: item?.feedback,
        });
      }

      // if (resp?.data?.length > 0) {
      //   setChatMessages(resp?.data ?? []);
      // } else {
      //   setChatMessages([]);
      // }

      setState({
        loading_screen: false,
        refreshing: false,
      });
    } catch (error) {
      setState({
        loading_screen: false,
        refreshing: false,
      });
      console.log(error);
    }
  };

  const handleGetUserCurrentLocation = async () => {
    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          const latitude = position.coords.latitude;
          // const longitude = position.coords.longitude;
          const pickupLocation = await apiServices.getFromApi(
            `helper/get-address?lat=${latitude}&lng=${latitude}`,
            ""
          );
          setCurrentLocation(pickupLocation?.result);
        });
      } else {
        console.log("Geolocation not supported");
      }
    } catch (error) {
      console.error("Error in location retrieval:", error);
    }
  };

  const handleCounterOffer = async () => {
    try {
      setState({
        disable_link_btn: true,
      });

      if (!state?.new_nego_price) {
        Toast.Error("Entrez le montant s'il vous plaît");
        setState({
          disable_link_btn: false,
          disable_btn: false,
        });
        return;
      }

      let text = state?.new_nego_price
        .replaceAll("،", ".")
        .replaceAll(".", ".")
        .replaceAll(",", ".")
        .replaceAll("，", ".");
      if (isNaN(Number(text))) {
        alert(
          selector.lang === "fr"
            ? `Veuillez entrer un montant valide.`
            : "Please enter a valid amount"
        );
        setState({
          disable_btn: false,
          disable_link_btn: false,
        });
        return;
      }

      const resp = await apiServices.postFromApi(
        "c2c-shipment-negotiations/reject",
        {
          negotiation_id: state?.lastOffer?.id,
        },
        ""
      );
      if (resp.status === 200) {
        handleNewMessageWithNegotiate(text);
        setState({
          disable_link_btn: false,
          new_nego_price: "",
        });
      } else {
        Toast.Error(
          `${
            typeof resp?.error === "string"
              ? resp?.error
              : resp?.error?.message ??
                resp?.error?.isNotEmpty ??
                resp?.error?.error ??
                ""
          }`
        );
        setState({
          disable_link_btn: false,
          disable_btn: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewMessage = async (path?: any, _document?: any) => {
    try {
      const item = announcement_details;
      setTimeout(() => {
        setState({ disable_btn: false });
      }, 3000);

      let new_msg: any = {
        message: message ?? null,
        message_status: "sent",
        order_id: `${item?.id}`,
        is_negotiate: false,
        order_details: null,
        sender_id: `${user?.id}`,
        ship_id: item?.id,
        created_at: new Date().toISOString(),
      };
      const findCustomer = state.product_details?.negotiations?.find(
        (i: any) => i.accepter_id
      );
      // console.log("new_msg",state?.product_details);


      if (`${user?.id}` === `${state.product_details?.customer_id}`) {
        new_msg.receiver_id = state?.product_details?.acc_id;
      } else {
        new_msg.receiver_id = `${state.product_details?.customer_id}`;
      }

      // console.log("new_msg",state?.product_details);


      if (state.show_preview && state.upload_type === "location") {
        new_msg.location = {
          type: "Point",
          coordinates: [state.latitude ?? 0, state.longitude ?? 0],
        };
        new_msg.file_type = "location";
      }
      
      setState({
        show_preview: false,
      });
      if (path) {
      } else if (_document) {
        let formData = new FormData();
        formData.append("file", _document);
        new_msg.file_type = state.upload_type;
        new_msg.file_name = _document?.name ?? _document?.fileName;
        new_msg.file_size = `${_document?.size}`;
        new_msg.file_url = _document?.uri;
        chatMessages.push(new_msg);
        const resp = await axios({
          baseURL: `${BASE_URL}upload/upload-file`,
          headers: {
            "Content-Type": "multipart/form-data", // this is important
          },
          method: "post",
          data: formData,
        });

        if (resp.data?.url) {
          new_msg.file_url = resp.data?.url;

          await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);
          await apiServices.postFromApi("chat/send-new-message", new_msg, "");
          setMessage("");
        }
      } else {
        await addDoc(collection(firestoreDB, "chat_negotiations"), new_msg);
        await apiServices.postFromApi("chat/send-new-message", new_msg, "");
        setMessage("");
      }
      setState({
        temp_document: null,
        upload_type: null,
        temp_gallery: null,
        base_image_uri: null,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewMessageWithNegotiate = async (amount?: number) => {
    try {
      const item = announcement_details;
      setTimeout(() => {
        setState({
          disable_btn: false,
        });
      }, 3000);
      // let text = amount
      //   ? amount
      //   : message
      //       ?.replaceAll("،", ".")
      //       ?.replaceAll(".", ".")
      //       ?.replaceAll(",", ".")
      //       ?.replaceAll("，", ".");
      // if (isNaN(Number(text))) {
      //   alert(
      //     selector.lang === "fr"
      //       ? `Veuillez entrer un montant valide.`
      //       : "Please enter a valid amount"
      //   );
      //   setState({
      //     disable_btn: false,
      //   });

      //   return;
      // }

      let new_msg: any = {
        message: `has sent you a message. neg_amt=${Number(amount)}`,
        message_status: "sent",
        order_id: item?.id,
        is_negotiate: true,
        order_details: null,
        sender_id: `${user?.id}`,
        created_at: new Date().toISOString(),
      };
      const findCustomer = state.product_details?.negotiations?.find(
        (i: any) => i.accepter_id
      );

      if (`${user?.id}` === `${state.product_details?.customer_id}`) {
        new_msg.receiver_id = `${findCustomer?.accepter_id}`;
      } else {
        new_msg.receiver_id = `${state.product_details?.customer_id}`;
      }

      let obj = {
        parent_id:
          state?.product_details?.negotiations?.[
            state?.product_details?.negotiations?.length - 1
          ]?.id,
        ship_id: Number(item?.id),
        ship_price: Number(amount ?? 0),
      };
      const resp = await apiServices.postFromApi(
        "/c2c-shipment-negotiations",
        obj,
        ""
      );
      if (resp.status === 201) {
        Toast.showSuccess(strings.offer_request_sent);
        // await apiServices.postFromApi("chat/send-new-message", new_msg, "");
        await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg); //chat/send-new-message

        getMessages();
        setMessage("");
        setState({
          temp_document: null,
          upload_type: null,
          temp_gallery: null,
          base_image_uri: null,
          openOffer: false,
          disable_btn: false,
          disable_link_btn: false,
        });
      } else {
        Toast.Error(
          `${resp.error?.message ?? resp?.message ?? resp?.error?.error ?? ""}`
        );
        setState({
          disable_link_btn: false,
          disable_btn: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleStripeCallBack = async () => {
    try {
      let new_msg: any = {
        message: `The payment was confirmed successfully!`,
        message_status: "sent",
        order_id: `${state?.product_details?.id ?? ""}`,
        is_negotiate: true,
        payment_msg: true,
        order_details: null,
        sender_id: `${selector?.user?.id}`,
        receiver_id: `${state?.product_details?.transporter_details?.id}`,
        created_at: new Date().toISOString(),
        ship_id: `${state?.product_details?.id}`,
      };
      await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);
      getMessages();

      setState({
        options: null,
        showStripeForm: false,
        show_stripe: false,
        showValidPayment: true,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const _last_message = chatMessages?.[chatMessages?.length - 1];
  const last_nego =
    state.product_details?.negotiations?.[
      state.product_details?.negotiations?.length - 1
    ];

  const findAccepter = state.product_details?.negotiations?.find(
    (i: any) => i.accepter_id // && i?.is_accepted
  );

  const handleValidatePromo = async () => {
    try {
      const data = state.product_details;
      let total_amt = 0,
        platform_fee = Number(data?.service_charges ?? 0);
      if (data?.handling) {
        total_amt =
          data?.order_amount_detail?.sub_total > 0
            ? Number(data?.order_amount_detail?.sub_total ?? 0)
            : Number(data?.agree_ship_price ?? data?.ship_price ?? 0) +
              Number(
                (Number(data?.agree_ship_price ?? data?.ship_price ?? 0) /
                  100) *
                  Number(data?.handling?.handling_charges_percent)
              ) +
              Number(data?.service_charges ?? 0);
      } else {
        total_amt =
          data?.order_amount_detail?.sub_total > 0
            ? Number(data?.order_amount_detail?.sub_total ?? 0) +
              Number(data?.service_charges ?? 0)
            : Number(data?.agree_ship_price ?? data?.ship_price ?? 0) +
              Number(data?.service_charges ?? 0);
      }
      const promo_resp = await apiServices.postFromApi(
        "c2c-promo-codes/validate-announce",
        {
          order_id: Number(state.product_details?.id),
          channel: "web",
          actual_order_amount: Number(
            data?.agree_ship_price ?? data?.ship_price ?? 0
          ),
          total_shipment_amt: 0,
          platform_fee: platform_fee,
          total_amount: total_amt,
          promo_code: `${state.promo_code_text ?? ""}`?.toLowerCase(),
          promo_code_type: "announcement",
        },
        ""
      );
      if (promo_resp.status === 200) {
        const resp = await apiServices.postFromApi(
          "stripe/regenerate-payment-intent-announce",
          {
            ship_id: Number(state.product_details?.id),
          },
          ""
        );
        if (resp?.status === 200 || resp?.status === 201) {
          // handleGetProdInfo(param?.id);
          getMessages();
          Toast.showSuccess("Code promotionnel appliqué 🥳");
          setState({ doNotShowPromo: false, show_stripe: false });
          setState({ show_stripe: true });
        }
      } else {
        Toast.Error(
          selector.lang === "en"
            ? "Invalid promo code"
            : "Code promotionnel invalide"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleComplete = (otpValue: any) => {
    if (otp?.length === 4) {
      if (state.product_details?.ship_status === "Accepted") {
        handlePickOrder(otp);
        return;
      }
      if (state.product_details?.ship_status === "Picked") {
        handleDeliverOrder(otp);
        return;
      }
    }
  };
  const handlePickOrder = async (otp: any) => {
    try {
      let obj = {
        ship_id: Number(state.product_details.id),
        ship_status: "Picked",
        ship_pickup_otp: Number(otp),
      };

      let resp = await apiServices.postFromApi(
        "c2c-shipments/update-status",
        obj,
        ""
      );
      if (resp?.status === 201 || resp?.status === 200) {
        Toast.showSuccess(
          selector.lang === "en"
            ? `Your delivery moves on to the next step :package:`
            : "Votre livraison passe à l'étape suivante :package:"
        );

        let new_msg: any = {
          message: `The Pickup OTP validated successfully!`,
          message_status: "sent",
          order_id: `${state?.product_details?.id ?? ""}`,
          is_negotiate: true,
          pickup_otp: true,
          order_details: null,
          sender_id: `${selector?.user?.id}`,
          receiver_id: `${state?.product_details?.transporter_details?.id}`,
          created_at: new Date().toISOString(),
          ship_id: `${state?.product_details?.id}`,
        };
        await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);
        setState({ showPickupOtpScreen: false });
        getMessages();
        setOtp("");
        return;
      } else {
        Toast.Error(strings?.pickup_otp_for_transporter ?? resp?.error);
      }
    } catch (error) {}
  };
  const handleDeliverOrder = async (otp: any) => {
    try {
      let obj = {
        ship_id: Number(state.product_details?.id),
        ship_status: "Deliver",
        ship_deliver_otp: Number(otp),
      };

      let resp = await apiServices.postFromApi(
        "c2c-shipments/update-status",
        obj,
        ""
      );
      if (resp?.status === 201 || resp?.status === 200) {
        Toast.showSuccess(
          selector.lang === "en"
            ? `Your delivery moves on to the next step :package:`
            : "Votre livraison passe à l'étape suivante :package:"
        );
        let new_msg: any = {
          message: `Delivery OTP Validated Successfully`,
          message_status: "sent",
          order_id: `${state?.product_details?.id ?? ""}`,
          is_negotiate: true,
          deliver_otp: true,
          order_details: null,
          sender_id: `${selector?.user?.id}`,
          receiver_id: `${state?.product_details?.transporter_details?.id}`,
          created_at: new Date().toISOString(),
          ship_id: `${state?.product_details?.id}`,
        };
        await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);
        setState({ showPickupOtpScreen: false });
        getMessages();
        setOtp("");
      } else {
        Toast.Error(
          resp?.data?.error ??
            resp?.error?.error ??
            resp?.data?.isEmail ??
            resp?.data?.isNotEmpty ??
            resp?.message ??
            "Something went wrong. Please wait a short while and try again. If problem persists then contact to support team."
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRating = async (item: any) => {
    try {
      setState({ openRating: true });
      const resp = await apiServices.getFromApi(
        `c2c/get-user-details/${item}`,
        ""
      );
      // console.log(resp, "respp");

      let avg_rating_ = resp.data?.ratings2?.reduce((a: any, b: any) => {
        return a + b.rating;
      }, 0);
      let avg_rating = isNaN(avg_rating_ / resp?.data?.ratings2?.length)
        ? 0
        : avg_rating_ / resp?.data?.ratings2?.length;
      setState({
        allRatings: resp?.data,
        reviews: resp?.data?.ratings2,
        details: {
          ...resp.data,
          avg_rating,
        },
      });
    } catch (error) {}
  };
  // React.useEffect(()=>{getRating()})
  const onInputChange = (e: any) => {
    try {
      const { value, name } = e.target;
      if (value[0] === " ") {
        return;
      }

      setState({
        [name]: value,
      });
    } catch (error) {}
  };
  const handleAddFeedback = async () => {
    try {
      let obj: any = {
        order_id: Number(state.product_details?.id),

        rating: state?.ratingsCount ?? 1,
        feedback: state?.feedback,
      };
      // check conditions
      if (user?.id === state?.product_details?.user_details?.id) {
        obj.rating_to_id = `${state.product_details?.acc_id}`;
        obj.rating_from_id = `${state.product_details?.user_details?.id}`;
      } else {
        obj.rating_to_id = `${state.product_details?.user_details?.id}`;
        obj.rating_from_id = `${state.product_details?.acc_id}`;
      }

      // return;

      let resp = await apiServices.postFromApi(
        "c2c-feedbacks",
        { data: [obj] },
        ""
      );

      if (resp?.status === 200 || resp?.status === 201) {
        // handleGetProdInfo(state.job_details?.id);

        let obj: any = {
          id: Number(state.product_details?.id),
          customer_id: Number(selector?.user?.id),
        };

        const resp = await apiServices.postFromApi(
          `c2c-shipments/details`,
          obj,
          ""
        );

        Toast.showSuccess("Notes attribuées au transporteur avec succès");

        setState({
          feedbackDialog: false,
          user_feedback: resp?.data?.feedback,
        });
      }
    } catch (error) {}
  };

  const theme = useTheme();

  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            height: "calc(90vh - 200px)",
            overflowY: "auto",
          }}
          ref={scrollRef}
        >
          {screen_1024 ? (
            <div
              style={{
                padding: 20,
                marginTop: 20,
                display: "flex",
                flexDirection: "column",
                position: "relative",
                rowGap: 30,
                borderRadius: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: 16,
                }}
              >
                <div>
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="36" height="36" rx="18" fill="#F4F3F6" />
                    <path
                      d="M14.7717 19.6682C15.1417 21.1059 16.4468 22.1682 18 22.1682C19.5532 22.1682 20.8583 21.1059 21.2283 19.6682M17.1814 10.3049L11.5295 14.7009C11.1517 14.9947 10.9628 15.1416 10.8267 15.3256C10.7061 15.4886 10.6163 15.6722 10.5617 15.8675C10.5 16.0879 10.5 16.3272 10.5 16.8058V22.8349C10.5 23.7683 10.5 24.235 10.6817 24.5916C10.8414 24.9052 11.0964 25.1601 11.41 25.3199C11.7665 25.5016 12.2332 25.5016 13.1667 25.5016H22.8333C23.7668 25.5016 24.2335 25.5016 24.59 25.3199C24.9036 25.1601 25.1586 24.9052 25.3183 24.5916C25.5 24.235 25.5 23.7683 25.5 22.8349V16.8058C25.5 16.3272 25.5 16.0879 25.4383 15.8675C25.3837 15.6722 25.2939 15.4886 25.1733 15.3256C25.0372 15.1416 24.8483 14.9947 24.4705 14.7009L18.8186 10.3049C18.5258 10.0772 18.3794 9.96335 18.2178 9.91959C18.0752 9.88097 17.9248 9.88097 17.7822 9.91959C17.6206 9.96335 17.4742 10.0772 17.1814 10.3049Z"
                      stroke="#2D26E6"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <div
                    style={{
                      fontFamily: "montserrat-Regular",
                      fontSize: 14,
                      lineHeight: "20px",
                    }}
                  >
                    Adresse de ramassage
                  </div>
                  <div
                    style={{
                      fontFamily: "montserrat-SemiBold",
                      fontSize: 16,
                      lineHeight: "24px",
                    }}
                  >
                    {state.product_details?.pickup?.address ?? "N/A"}
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: "absolute",
                  left: 37,
                  top: 60,
                }}
              >
                <svg
                  width="1"
                  height="30"
                  viewBox="0 0 1 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="0.5"
                    y1="2.18557e-08"
                    x2="0.499999"
                    y2="30"
                    stroke="#BCBBC4"
                    stroke-dasharray="4 4"
                  />
                </svg>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: 16,
                }}
              >
                <div>
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="36" height="36" rx="18" fill="#F4F3F6" />
                    <path
                      d="M18 18.416C19.3807 18.416 20.5 17.2967 20.5 15.916C20.5 14.5353 19.3807 13.416 18 13.416C16.6193 13.416 15.5 14.5353 15.5 15.916C15.5 17.2967 16.6193 18.416 18 18.416Z"
                      stroke="#EF6A31"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18 26.3327C19.6667 22.9993 24.6667 20.8479 24.6667 16.3327C24.6667 12.6508 21.6819 9.66602 18 9.66602C14.3181 9.66602 11.3333 12.6508 11.3333 16.3327C11.3333 20.8479 16.3333 22.9993 18 26.3327Z"
                      stroke="#EF6A31"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <div
                    style={{
                      fontFamily: "montserrat-Regular",
                      fontSize: 14,
                      lineHeight: "20px",
                    }}
                  >
                    Adresse de livraison
                  </div>
                  <div
                    style={{
                      fontFamily: "montserrat-SemiBold",
                      fontSize: 16,
                      lineHeight: "24px",
                    }}
                  >
                    {state.product_details?.dropoff?.address ?? "N/A"}
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <div
            style={{
              fontFamily: "montserrat-Regular",
              cursor: "pointer",
              display: "none", //comment by asad iqbal from ppt (17/1/25)
              alignItems: "center",
              gap: 5,
              margin: 5,
            }}
            onClick={() => {
              getMessages();
            }}
          >
            <RefrestIcon fill={defaultLabelColors.main_blue} /> Refresh
          </div>
          <div style={{ padding: "10px 10px" }}>
            <div
              style={{
                gap: 17,
                marginTop: 10,
                marginBottom: 10,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  borderRadius: 16,
                  borderTopLeftRadius: 4,
                  alignSelf: "flex-start",
                  display: "flex",
                  flexDirection: "row",
                  columnGap: screen_1024 ? 14 : 8,
                }}
              >
                <img
                  alt="profile-pic"
                  src={
                    `${state?.product_details?.customer_id}` === `${user?.id}`
                      ? state?.product_details?.negotiations[0]?.profile_pic ??
                        no_profile_image
                      : state?.product_details?.user_details?.profile_pic ??
                        no_profile_image
                  }
                  onError={(e) => {
                    e.currentTarget.onerror = null; // prevent infinite loop
                    e.currentTarget.src = no_profile_image;
                  }}
                  style={{
                    height: screen_1024 ? 50 : 42,
                    width: screen_1024 ? 50 : 42,
                    objectFit: "contain",
                    borderRadius: "100%",
                    border: `1px solid lightgray`,
                  }}
                />
                <div
                  style={{
                    borderRadius: 16,
                    borderTopLeftRadius: 4,
                    background: "#F4F3F6",
                    padding: 16,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (
                      Number(state?.product_details?.user_details?.id) !==
                      user?.id
                    ) {
                      getRating(state?.product_details?.user_details?.id);
                      return;
                    }
                    if (
                      Number(state?.product_details?.user_details?.id) ===
                      user?.id
                    ) {
                      getRating(
                        state?.product_details?.acc_id
                          ? state?.product_details?.acc_id
                          : state?.product_details?.negotiations?.[0]
                              ?.accepter_id
                      );
                      return;
                    }
                  }}
                >
                  <div
                    style={{
                      fontFamily: "montserrat-SemiBold",
                      color: defaultLabelColors.main_font,
                      fontSize: screen_1024 ? 18 : 14,
                    }}
                  >
                    
                    {
                    
                    `${state?.product_details?.customer_id}` === `${user?.id}`
                      ?
                      state?.product_details?.ship_status_level > 1 ? 
                      state?.product_details?.transporter_details?.cus_name :
                      state?.product_details?.negotiations[0]?.added_by
                      : state?.product_details?.user_details?.cus_name}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: 14,
                    }}
                  >
                    <p
                      style={{
                        fontSize: screen_1024 ? 22 : 18,
                        fontFamily: "montserrat-SemiBold",
                        color: defaultLabelColors.main_font_brown,
                        margin: 0,
                      }}
                    >
                      {`${state?.product_details?.customer_id}` ===
                      `${user?.id}`
                        ? currencyFormat(
                            state?.product_details?.negotiations[0]?.cus_ratings?.toFixed(
                              1
                            )
                          )
                        : currencyFormat(
                            state?.product_details?.user_details?.cus_ratings?.toFixed(
                              1
                            )
                          )}
                      <svg
                        width="20"
                        height="19"
                        viewBox="0 0 20 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.60306 1.91176C9.63958 1.83798 9.696 1.77587 9.76594 1.73245C9.83588 1.68903 9.91657 1.66602 9.9989 1.66602C10.0812 1.66602 10.1619 1.68903 10.2319 1.73245C10.3018 1.77587 10.3582 1.83798 10.3947 1.91176L12.3197 5.81093C12.4465 6.06757 12.6337 6.2896 12.8652 6.45797C13.0968 6.62634 13.3657 6.73602 13.6489 6.77759L17.9539 7.40759C18.0355 7.41941 18.1121 7.45382 18.1751 7.50693C18.2382 7.56003 18.2851 7.62972 18.3106 7.7081C18.3361 7.78648 18.3391 7.87043 18.3194 7.95046C18.2996 8.03048 18.2579 8.10339 18.1989 8.16093L15.0856 11.1926C14.8802 11.3927 14.7266 11.6397 14.6379 11.9123C14.5492 12.1849 14.5281 12.475 14.5764 12.7576L15.3114 17.0409C15.3258 17.1225 15.317 17.2064 15.286 17.2832C15.255 17.3599 15.203 17.4264 15.136 17.4751C15.069 17.5237 14.9897 17.5526 14.9071 17.5583C14.8245 17.5641 14.742 17.5465 14.6689 17.5076L10.8206 15.4843C10.567 15.3511 10.2849 15.2816 9.99848 15.2816C9.71208 15.2816 9.42996 15.3511 9.1764 15.4843L5.3289 17.5076C5.25584 17.5463 5.17339 17.5637 5.09094 17.5578C5.00848 17.5519 4.92933 17.5231 4.86247 17.4744C4.79562 17.4258 4.74376 17.3594 4.71278 17.2828C4.6818 17.2061 4.67294 17.1223 4.68723 17.0409L5.4214 12.7584C5.46989 12.4757 5.44888 12.1854 5.36018 11.9126C5.27147 11.6398 5.11774 11.3927 4.91223 11.1926L1.7989 8.16176C1.73939 8.10429 1.69722 8.03126 1.6772 7.95099C1.65717 7.87072 1.66009 7.78644 1.68563 7.70775C1.71116 7.62906 1.75828 7.55913 1.82163 7.50591C1.88497 7.4527 1.96198 7.41834 2.0439 7.40676L6.34806 6.77759C6.63161 6.73634 6.90089 6.62681 7.13272 6.45842C7.36454 6.29002 7.55198 6.06782 7.6789 5.81093L9.60306 1.91176Z"
                          fill="black"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </p>
                  </div>
                </div>
              </div>

              <div
                style={{
                  borderRadius: 16,
                  borderTopRightRadius: 4,
                  alignSelf: "flex-end",
                  display: "flex",
                  flexDirection: "row-reverse",
                  columnGap: screen_1024 ? 14 : 8,
                  cursor: "pointer",
                }}
                onClick={() => {
                  getRating(user?.id);
                }}
              >
                <img
                  alt="profile-pic"
                  src={user?.profile_pic ?? no_profile_image}
                  onError={(e) => {
                    e.currentTarget.onerror = null; // prevent infinite loop
                    e.currentTarget.src = no_profile_image;
                  }}
                  style={{
                    height: screen_1024 ? 50 : 42,
                    width: screen_1024 ? 50 : 42,
                    objectFit: "contain",
                    borderRadius: "100%",
                    border: `1px solid lightgray`,
                  }}
                />
                <div
                  style={{
                    borderRadius: 16,
                    borderTopRightRadius: 4,
                    background: "#FCE6DD",
                    padding: 16,
                  }}
                >
                  <div
                    style={{
                      fontFamily: "montserrat-SemiBold",
                      fontSize: screen_1024 ? 18 : 14,
                      color: defaultLabelColors.main_font,
                    }}
                  >
                    {`${user?.first_name ?? ""}${
                      user?.surname ? ` ${user?.surname ?? ""}` : ""
                    }`}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: 14,
                      justifyContent: "flex-end",
                    }}
                  >
                    <p
                      style={{
                        fontSize: screen_1024 ? 22 : 18,
                        fontFamily: "montserrat-SemiBold",
                        color: defaultLabelColors.main_font_brown,
                        margin: 0,
                        textAlign: "right",
                      }}
                    >
                      {currencyFormat(user?.rating?.toFixed(1)) ?? "---"}
                      <svg
                        width="20"
                        height="19"
                        viewBox="0 0 20 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.60306 1.91176C9.63958 1.83798 9.696 1.77587 9.76594 1.73245C9.83588 1.68903 9.91657 1.66602 9.9989 1.66602C10.0812 1.66602 10.1619 1.68903 10.2319 1.73245C10.3018 1.77587 10.3582 1.83798 10.3947 1.91176L12.3197 5.81093C12.4465 6.06757 12.6337 6.2896 12.8652 6.45797C13.0968 6.62634 13.3657 6.73602 13.6489 6.77759L17.9539 7.40759C18.0355 7.41941 18.1121 7.45382 18.1751 7.50693C18.2382 7.56003 18.2851 7.62972 18.3106 7.7081C18.3361 7.78648 18.3391 7.87043 18.3194 7.95046C18.2996 8.03048 18.2579 8.10339 18.1989 8.16093L15.0856 11.1926C14.8802 11.3927 14.7266 11.6397 14.6379 11.9123C14.5492 12.1849 14.5281 12.475 14.5764 12.7576L15.3114 17.0409C15.3258 17.1225 15.317 17.2064 15.286 17.2832C15.255 17.3599 15.203 17.4264 15.136 17.4751C15.069 17.5237 14.9897 17.5526 14.9071 17.5583C14.8245 17.5641 14.742 17.5465 14.6689 17.5076L10.8206 15.4843C10.567 15.3511 10.2849 15.2816 9.99848 15.2816C9.71208 15.2816 9.42996 15.3511 9.1764 15.4843L5.3289 17.5076C5.25584 17.5463 5.17339 17.5637 5.09094 17.5578C5.00848 17.5519 4.92933 17.5231 4.86247 17.4744C4.79562 17.4258 4.74376 17.3594 4.71278 17.2828C4.6818 17.2061 4.67294 17.1223 4.68723 17.0409L5.4214 12.7584C5.46989 12.4757 5.44888 12.1854 5.36018 11.9126C5.27147 11.6398 5.11774 11.3927 4.91223 11.1926L1.7989 8.16176C1.73939 8.10429 1.69722 8.03126 1.6772 7.95099C1.65717 7.87072 1.66009 7.78644 1.68563 7.70775C1.71116 7.62906 1.75828 7.55913 1.82163 7.50591C1.88497 7.4527 1.96198 7.41834 2.0439 7.40676L6.34806 6.77759C6.63161 6.73634 6.90089 6.62681 7.13272 6.45842C7.36454 6.29002 7.55198 6.06782 7.6789 5.81093L9.60306 1.91176Z"
                          fill="black"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </p>
                  </div>
                </div>
              </div>

              {state?.product_details?.negotiations?.map(
                (nego_item: any, index: number) => {
                  return nego_item.created_by === user?.id ? (
                    screen_1024 ? (
                      <div
                        style={{
                          background: "#DCDBFB",
                          borderRadius: 20,
                          padding: 16,
                          display: "flex",
                          flexDirection: "column",
                          rowGap: 17,
                          width: 587,
                          maxWidth: "80%",
                          alignSelf:
                            nego_item.sender_id === user?.id
                              ? "flex-end"
                              : "flex-end",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            columnGap: 14,
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-SemiBold",
                              lineHeight: "24px",
                              color: color_theme.black,
                            }}
                          >
                            {nego_item?.is_accepted
                              ? `Vous avez accepté l’offre  ${
                                  Number(nego_item.sender_id) === Number(user?.id)
                                    ? "du transporteur."
                                    : "de l’expéditeur."
                                }`
                              : `Vous avez fait une contre-offre pour ${currencyFormat(
                                  nego_item?.ship_price ?? 0
                                )} €`}

                            {/* Vous avez fait une contre-offre pour{" "}
                          {currencyFormat(nego_item?.ship_price ?? 0)}  */}
                          </div>
                          <div
                            style={{
                              fontSize: 14,
                              fontFamily: "montserrat-Regular",
                              lineHeight: "20px",
                              color: "#4B4A61",
                            }}
                          >
                            {nego_item?.created_at
                              ? moment().format("YYYY-MM-DD") !==
                                moment(nego_item?.created_at).format(
                                  "YYYY-MM-DD"
                                )
                                ? moment(
                                    `${nego_item?.created_at}`.endsWith("Z")
                                      ? nego_item?.created_at
                                      : nego_item?.created_at + "Z"
                                  ).format("DD/MM/YYYY HH:mm")
                                : moment(
                                    `${nego_item?.created_at}`.endsWith("Z")
                                      ? nego_item?.created_at
                                      : `${nego_item?.created_at}Z`
                                  ).format("HH:mm")
                              : ""}
                          </div>
                        </div>
                        {!nego_item?.is_accepted && (
                          <div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#616161",
                                fontFamily: "montserrat-Regular",
                              }}
                            >
                              {nego_item.sender_id === user?.id
                                ? "Votre contre-offre a bien été envoyée au transporteur."
                                : "Votre contre-offre a bien été envoyée à l’expéditeur."}{" "}
                              {/* {state?.product_details?.negotiations[index - 1]
                            ?.added_by ?? state?.product_details?.added_by}
                          . */}
                            </div>
                            <div
                              style={{
                                fontSize: 16,
                                color: "#616161",
                                fontFamily: "montserrat-Regular",
                              }}
                            >
                              Vous devez attendre qu’il accepte pour discuter.
                            </div>
                          </div>
                        )}
                      </div>
                    ) : nego_item?.is_accepted ? (
                      <div
                        style={{
                          background: "#F4F3F6",
                          borderRadius: "16px 16px 0px 16px",
                          padding: 12,
                          display: "flex",
                          rowGap: 17,
                          width: 587,
                          maxWidth: "80%",
                          alignSelf:
                            // nego_item.accepter_id === user?.id
                            // ?
                            // "flex-end",
                            // :
                            "flex-start",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            fontFamily: "montserrat-Regular",
                            color: "#000",
                            fontSize: "14px",
                          }}
                        >
                          {
                            `${
                              state?.product_details?.negotiations[0]
                                ?.added_by ?? ""
                            }`.split(" ")?.[0]
                          }
                          , vous avez fait une <br />
                          offre pour un montant de :
                        </div>
                        <div
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            fontSize: "16px",
                          }}
                        >
                          {nego_item?.ship_price} €
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          background: "#DCDBFB",
                          borderRadius: "16px 16px 0px 16px",
                          padding: 12,
                          display: "flex",
                          rowGap: 17,
                          width: 587,
                          maxWidth: "80%",
                          alignSelf:
                            // nego_item.accepter_id === user?.id
                            // ?
                            "flex-end",
                          // : "flex-start",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            fontFamily: "montserrat-Regular",
                            color: "#000",
                            fontSize: "14px",
                          }}
                        >
                          vous avez fait une <br />
                          offre pour un montant de :
                        </div>
                        <div
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            fontSize: "16px",
                          }}
                        >
                          {nego_item?.ship_price} €
                        </div>
                      </div>
                    )
                  ) : screen_1024 ? (
                    <div
                      key={`REQUESTER_ITEM_${index + 1}`}
                      style={{
                        display:
                          nego_item?.is_accepted === true ? "none" : "flex",
                        flexDirection: "column",
                      }}
                    >
                      <p
                        style={{
                          textAlign: "center",
                          fontFamily: "montserrat-Regular",
                          fontSize: 12,
                          margin: 0,
                          marginBottom: "5px",
                          color: "#4B4A61",
                        }}
                      >
                        {moment(
                          `${nego_item?.created_at}`.endsWith("Z")
                            ? nego_item?.created_at
                            : nego_item?.created_at + "Z"
                        ).format("DD MMM YYYY - HH:mm")}
                      </p>
                      <div
                        style={{
                          // borderRadius: 16,
                          // backgroundColor: "#F4F3F6",
                          padding: 15,
                          borderWidth: 1,
                          borderColor: "#F4F3F6",
                          display: "flex",
                        }}
                        className="bg-image"
                      >
                        <div
                          style={{
                            flex: 1,
                            justifyContent: "space-between",
                            alignContent: "center",
                            flexWrap: "wrap",
                            width: "100%",
                            display: "flex",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                fontSize: 20,
                                color: "#fff",
                                fontFamily: "montserrat-SemiBold",
                                margin: 0,
                              }}
                            >
                              Nouvelle offre
                              <br />
                              <span
                                style={{
                                  fontSize: 16,
                                  color: "#fff",
                                  fontFamily: "montserrat-Regular",
                                  margin: 0,
                                }}
                              >
                                Offre initiale :{" "}
                                {currencyFormat(
                                  state?.product_details?.negotiations?.[
                                    index - 1
                                  ]?.ship_price ??
                                    state?.product_details?.ship_price ??
                                    0
                                )}{" "}
                                €
                              </span>
                            </p>
                            <p
                              style={{
                                fontSize: "26px",
                                color: "#fff",
                                // state.product_details?.ship_status_level === 2
                                //   ? color_theme.black_40
                                //   : state?.product_details?.negotiations[
                                //       index + 1
                                //     ]?.is_accepted === true
                                //   ? color_theme.black_40
                                //   : nego_item?.is_accepted === false
                                //   ? color_theme.black_40
                                //   : color_theme.white,
                                fontFamily: "montserrat-Bold",
                                margin: 0,
                                paddingRight: 15,
                                flex: 1,
                                textAlign:
                                  state.product_details?.ship_status_level === 2
                                    ? "right"
                                    : state?.product_details?.negotiations[
                                        index + 1
                                      ]?.is_accepted === true
                                    ? "right"
                                    : nego_item?.is_accepted === false
                                    ? "right"
                                    : "center",
                              }}
                            >
                              {currencyFormat(nego_item?.ship_price, "fr-FR")} €
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            flexDirection: "row",
                            justifyContent: "center",
                            display:
                              state.product_details?.ship_status_level === 2
                                ? "none"
                                : last_nego?.is_accepted === true
                                ? "none"
                                : nego_item?.is_accepted === null
                                ? `${nego_item?.created_by}` === `${user?.id}`
                                  ? "none"
                                  : "flex"
                                : "none",
                          }}
                        >
                          <div
                            style={{
                              padding: 5,
                            }}
                            onClick={() => {
                              setState({
                                openOffer: true,
                                lastOffer: nego_item,
                              });
                            }}
                          >
                            <p
                              style={{
                                color: "#fff",
                                border: "1px solid #BCBBC4",
                                padding: "12px 24px",
                                borderRadius: "12px",
                                fontFamily: "montserrat-Bold",
                                cursor: "pointer",
                                fontSize: "14px",
                                background: "transparent",
                              }}
                            >
                              Faire une contre-offre
                            </p>
                          </div>
                          <div
                            style={{
                              padding: 5,
                            }}
                            onClick={async () => {
                              if (
                                state.product_details?.ship_status_level === 2
                              ) {
                                alert(
                                  "Unfortunetly the sender acceptes the another driver's request 🥺🥺"
                                );
                              }
                              if (state.disable_btn) return;
                              try {
                                setState({
                                  disable_btn: true,
                                });
                                let nego_obj = {
                                  parent_id: nego_item?.id,
                                  ship_id: nego_item?.ship_id,
                                  ship_price: Number(nego_item?.ship_price),
                                  is_accepted: true,
                                };
                                
                                const resp = await apiServices.postFromApi(
                                  "c2c-shipment-negotiations",
                                  nego_obj,
                                  ""
                                );
                                if (resp.status === 201) {
                                  let new_msg: any = {
                                    message: `offer accepted at ${state.new_nego_price}`,
                                    // message: message ?? null,
                                    message_status: "sent",
                                    order_id: `${nego_item?.ship_id}`,
                                    is_negotiate: true,
                                    order_details: null,
                                    sender_id: `${user?.id}`,
                                    created_at: new Date().toISOString(),
                                  };
                                  const findCustomer =
                                    state.product_details?.negotiations?.find(
                                      (i: any) => i.accepter_id
                                    );

                                  if (
                                    `${user?.id}` ===
                                    `${state.product_details?.customer_id}`
                                  ) {
                                    new_msg.receiver_id = `${findCustomer?.accepter_id}`;
                                  } else {
                                    new_msg.receiver_id = `${state.product_details?.customer_id}`;
                                  }
                                  await addDoc(
                                    collection(
                                      firestoreDB,
                                      `chat_negotiations`
                                    ),
                                    new_msg
                                  );

                                  // getMessages();

                                  setState({
                                    disable_btn: false,
                                  });
                                } else {
                                  Toast.Error(
                                    `${
                                      typeof resp?.error === "string"
                                        ? resp?.error
                                        : resp?.error?.message ??
                                          resp?.error?.isNotEmpty ??
                                          resp?.error?.error ??
                                          ""
                                    }`
                                  );

                                  setState({
                                    disable_btn: false,
                                  });
                                }
                              } catch (error) {}
                            }}
                          >
                            <p
                              style={{
                                color: defaultLabelColors.main_orange_new,
                                border: `1px solid ${color_theme.main_orange}`,
                                borderRadius: `12px`,
                                padding: `12px 24px`,
                                fontFamily: `montserrat-SemiBold`,
                                background: `${color_theme.white}`,
                                cursor: state.disable_btn ? "auto" : `pointer`,
                                fontSize: `14px`,
                              }}
                            >
                              {strings.accept}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      key={`REQUESTER_ITEM_${index + 1}`}
                      style={{
                        display:
                          nego_item?.is_accepted === true ? "none" : "flex",
                        flexDirection: "column",
                      }}
                    >
                      <p
                        style={{
                          textAlign: "center",
                          fontFamily: "montserrat-Regular",
                          fontSize: 12,
                          margin: 0,
                          marginBottom: "5px",
                          color: "#4B4A61",
                        }}
                      >
                        {moment(
                          `${nego_item?.created_at}`.endsWith("Z")
                            ? nego_item?.created_at
                            : nego_item?.created_at + "Z"
                        ).format("DD MMM YYYY - HH:mm")}
                      </p>
                      {nego_item?.is_accepted === null ? (
                        <div
                          style={{
                            // borderRadius: 16,
                            // backgroundColor: "#F4F3F6",
                            padding: 15,
                            borderWidth: 1,
                            borderColor: "#F4F3F6",
                            display: "flex",
                            flexDirection: "column",
                          }}
                          className="bg-image"
                        >
                          <div
                            style={{
                              flex: 1,
                              justifyContent: "space-between",
                              alignContent: "center",
                              flexWrap: "wrap",
                              width: "100%",
                              gap: "20px",
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontFamily: "montserrat-SemiBold",
                                  margin: 0,
                                }}
                              >
                                Nouvelle offre
                                <br />
                                <span
                                  style={{
                                    fontSize: 12,
                                    color: "#fff",
                                    fontFamily: "montserrat-Regular",
                                    margin: 0,
                                  }}
                                >
                                  Offre initiale :{" "}
                                  {currencyFormat(
                                    state?.product_details?.negotiations?.[
                                      index - 1
                                    ]?.ship_price ??
                                      state?.product_details?.ship_price ??
                                      0
                                  )}{" "}
                                  €
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "16px",
                                  color: "#fff",
                                  // state.product_details?.ship_status_level === 2
                                  //   ? color_theme.black_40
                                  //   : state?.product_details?.negotiations[
                                  //       index + 1
                                  //     ]?.is_accepted === true
                                  //   ? color_theme.black_40
                                  //   : nego_item?.is_accepted === false
                                  //   ? color_theme.black_40
                                  //   : color_theme.white,
                                  fontFamily: "montserrat-Bold",
                                  margin: 0,
                                  paddingRight: 15,
                                  paddingLeft: "20px",
                                  flex: 1,
                                  textAlign:
                                    state.product_details?.ship_status_level ===
                                    2
                                      ? "right"
                                      : state?.product_details?.negotiations[
                                          index + 1
                                        ]?.is_accepted === true
                                      ? "right"
                                      : nego_item?.is_accepted === false
                                      ? "right"
                                      : "left",
                                }}
                              >
                                {currencyFormat(nego_item?.ship_price, "fr-FR")}{" "}
                                €
                              </p>
                            </div>
                          </div>

                          <div
                            style={{
                              flexDirection: "column",
                              justifyContent: "center",
                              display:
                                state.product_details?.ship_status_level === 2
                                  ? "none"
                                  : last_nego?.is_accepted === true
                                  ? "none"
                                  : nego_item?.is_accepted === null
                                  ? `${nego_item?.created_by}` === `${user?.id}`
                                    ? "none"
                                    : "flex"
                                  : "none",
                            }}
                          >
                            <div
                              style={{
                                padding: "5px 0px",
                              }}
                              onClick={() => {
                                setState({
                                  openOffer: true,
                                  lastOffer: nego_item,
                                });
                              }}
                            >
                              <p
                                style={{
                                  color: "#fff",
                                  border: "1px solid #BCBBC4",
                                  padding: "12px 24px",
                                  borderRadius: "12px",
                                  fontFamily: "montserrat-Bold",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  background: "transparent",
                                  margin: 0,
                                  textAlign: "center",
                                }}
                              >
                                Faire une contre-offre
                              </p>
                            </div>
                            <div
                              style={{
                                padding: "5px 0px",
                              }}
                              onClick={async () => {
                                if (
                                  state.product_details?.ship_status_level === 2
                                ) {
                                  alert(
                                    "Unfortunetly the sender acceptes the another driver's request 🥺🥺"
                                  );
                                }
                                if (state.disable_btn) return;
                                try {
                                  setState({
                                    disable_btn: true,
                                  });
                                  let nego_obj = {
                                    parent_id: nego_item?.id,
                                    ship_id: nego_item?.ship_id,
                                    ship_price: Number(nego_item?.ship_price),
                                    is_accepted: true,
                                  };
                                  const resp = await apiServices.postFromApi(
                                    "c2c-shipment-negotiations",
                                    nego_obj,
                                    ""
                                  );
                                  if (resp.status === 201) {
                                    let new_msg: any = {
                                      message: `offer accepted at ${state.new_nego_price}`,
                                      // message: message ?? null,
                                      message_status: "sent",
                                      order_id: `${nego_item?.ship_id}`,
                                      is_negotiate: true,
                                      order_details: null,
                                      sender_id: `${user?.id}`,
                                      created_at: new Date().toISOString(),
                                    };
                                    const findCustomer =
                                      state.product_details?.negotiations?.find(
                                        (i: any) => i.accepter_id
                                      );

                                    if (
                                      `${user?.id}` ===
                                      `${state.product_details?.customer_id}`
                                    ) {
                                      new_msg.receiver_id = `${findCustomer?.accepter_id}`;
                                    } else {
                                      new_msg.receiver_id = `${state.product_details?.customer_id}`;
                                    }
                                    await addDoc(
                                      collection(
                                        firestoreDB,
                                        `chat_negotiations`
                                      ),
                                      new_msg
                                    );

                                    // getMessages();

                                    setState({
                                      disable_btn: false,
                                    });
                                  } else {
                                    Toast.Error(
                                      `${
                                        typeof resp?.error === "string"
                                          ? resp?.error
                                          : resp?.error?.message ??
                                            resp?.error?.isNotEmpty ??
                                            resp?.error?.error ??
                                            ""
                                      }`
                                    );

                                    setState({
                                      disable_btn: false,
                                    });
                                  }
                                } catch (error) {}
                              }}
                            >
                              <p
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                  border: `1px solid ${color_theme.main_orange}`,
                                  borderRadius: `12px`,
                                  padding: `12px 24px`,
                                  fontFamily: `montserrat-SemiBold`,
                                  background: `${color_theme.white}`,
                                  cursor: state.disable_btn
                                    ? "auto"
                                    : `pointer`,
                                  fontSize: `14px`,
                                  margin: 0,
                                  textAlign: "center",
                                }}
                              >
                                {strings.accept}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            background: "#F4F3F6",
                            borderRadius: "16px 16px 16px 0px",
                            padding: 12,
                            display: "flex",
                            rowGap: 17,
                            width: 587,
                            maxWidth: "80%",
                            alignSelf: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                              fontFamily: "montserrat-Regular",
                              color: "#000",
                              fontSize: "14px",
                            }}
                          >
                            {`${nego_item?.added_by ?? ""}`.split(" ")?.[0]},{" "}
                            vous avez fait une <br />
                            offre pour un montant de :
                          </div>
                          <div
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              fontSize: "16px",
                            }}
                          >
                            {nego_item?.ship_price} €
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }
              )}

              {/* {`${state.product_details?.customer_id}` !== `${user?.id}` &&
                state?.product_details?.ship_status_level === 2 && (
                  // added on 4/2/25
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div
                      style={{
                        width: "587px",
                        position: "relative",
                        height: "100px",
                        borderRadius: "16px",
                        justifyContent: "center",
                        // alignItems:'center',
                        background: defaultLabelColors.main_orange,
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: 10,
                        }}
                      >
                        <p
                          style={{
                            position: "relative",
                            color: "#fff",
                            fontSize: "18px",
                            fontFamily: "Raleway-Extra-Bold",
                            margin: 0,
                            marginTop: 0,
                          }}
                        >
                          L’expéditeur vient d’accepter votre offre. Vous pouvez
                          commencer à discuter”{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                )} */}
 

 


              {state?.product_details?.ship_status_level === 2 &&
                state?.product_details?.payment_status !== "Paid" && (
                  <div
                    style={{
                      width: "100%",
                      position: "relative",
                      height: screen_1024 ? "150px" : "122px",
                      // padding:"24px 10px",
                      borderRadius: "16px",
                      textAlign: "center",
                      gap: 10,
                      paddingTop: "10px",
                      justifyContent: "center",
                      // alignItems:'center',
                      display:
                        Number(state?.product_details?.customer_id) ===
                        Number(user?.id) && (Number(announcement_details.receiver_id) === Number(state.product_details?.acc_id) )
                          ? "flex"
                          : "none",
                    }}
                    className="bg-image"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        marginTop: "10px",
                      }}
                    >
                      <p
                        style={{
                          position: "relative",
                          color: "#fff",
                          fontSize: screen_1024 ? "20px" : "14px",
                          fontFamily: "montserrat-Bold",
                          margin: 0,
                        }}
                      >
                        L’offre a été acceptée 
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: screen_1024 ? "16px" : "12px",
                          color: "#fff",
                          margin: 0,
                        }}
                      >
                        Vous pouvez commencer à discuter
                      </p>
                      <p
                        style={{
                          margin: 0,
                          marginTop: screen_1024 ? 10 : "0px",
                          marginBottom: 20,
                        }}
                      >
                        <CustomButton
                          style={{
                            fontSize: screen_1024 ? "12px" : "14px",
                            fontWeight: "500",
                            color: state.enable_stripe
                              ? defaultLabelColors.main_orange_new
                              : color_theme.black_40,
                            fontFamily: "montserrat-SemiBold",
                            background: state.enable_stripe
                              ? color_theme.white
                              : color_theme.disabled,
                            border: "none",
                            borderRadius: "12px",
                            padding: "10px 30px 10px 30px",
                            minWidth: screen_1024 ? "200px" : "550px",
                            maxWidth: screen_1024 ? "300px" : "100%",
                            width: screen_1024 ? "260px" : "100%",
                            marginTop: "10px",
                          }}
                          disable={state.enable_stripe ? false : true}
                          value={
                            selector.lang === "en"
                              ? "Continue to Payment"
                              : `Continuer vers le paiement`
                          }
                          onClick={() => {
                            setState({ show_stripe: true });
                          }}
                        />
                      </p>
                    </div>
                  </div>
                )}

              {state?.product_details?.ship_status_level === 2 &&
                state?.product_details?.payment_status === "Paid" &&
                state?.product_details?.user_details?.id === user?.id &&
                screen_1024 && (
                  <div
                    className="bg-image"
                    style={{
                      width: "100%",

                      height: "120px",
                      borderRadius: "16px",
                      justifyContent: "center",
                      // background: defaultLabelColors.main_orange,
                      display:
                        Number(state?.product_details?.customer_id) ===
                        Number(user?.id)
                          && (announcement_details.receiver_id === state.product_details?.acc_id )
                            ? "flex"
                            : "none"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        paddingTop: "30px",
                      }}
                    >
                      <p
                        style={{
                          color: "#fff",
                          fontSize: "20px",
                          fontFamily: "montserrat-Bold",
                          margin: 0,
                        }}
                      >
                        L’offre a été acceptée
                      </p>

                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          color: "#fff",
                          fontSize: 16,
                          textAlign: "center",
                        }}
                      >
                        Vous pouvez commencer à discuter
                      </p>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingTop: "80px",
                        }}
                      >
                        <p
                          style={{
                            color: "#4B4A61",
                            fontSize: 14,
                            fontFamily: "montserrat-Regular",
                          }}
                        >
                          {state?.product_details?.payment_log &&
                            moment(
                              `${state?.product_details?.payment_log?.[0]?.created_at}`.endsWith(
                                "Z"
                              )
                                ? state?.product_details?.payment_log?.[0]
                                    ?.created_at
                                : state?.product_details?.payment_log?.[0]
                                    ?.created_at + "Z"
                            ).format("DD/MM/YYYY HH:mm")}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

              {state?.product_details?.ship_status_level > 1 &&
                state?.product_details?.payment_status === "Paid" &&
                state?.product_details?.user_details?.id === user?.id && (
                  // Number(state?.product_details?.acc_id) === Number(state?.product_details?.transporter_details?.id) &&
                  <div
                    className="bg-image"
                    style={{
                      width: "100%",
                      height: screen_1024 ? "220px" : "175px",
                      paddingBottom: "10px",
                      borderRadius: "16px",
                      justifyContent: "center",

                      display:(announcement_details.receiver_id === state.product_details?.acc_id )
                          ? "flex"
                          : "none",
                      // background: defaultLabelColors.main_orange,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        paddingTop: screen_1024 ? "30px" : "15px",
                      }}
                    >
                      <p
                        style={{
                          color: "#fff",
                          fontSize: screen_1024 ? "20px" : "14px",
                          fontFamily: "montserrat-Bold",
                          margin: 0,
                        }}
                      >
                        Ton paiement est validé !{" "}
                      </p>

                      <p
                        style={{
                          margin: 0,
                          fontFamily: "montserrat-Regular",
                          color: "#fff",
                          fontSize: screen_1024 ? "unset" : "12px",
                          marginTop: screen_1024 ? "0px" : "10px",
                        }}
                      >
                        Le montant sera transferé {screen_1024 ? " " : <br />}{" "}
                        une fois la livraison réalisé
                      </p>

                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          color: "#fff",
                          fontSize: screen_1024 ? 18 : 14,
                          textAlign: "center",
                        }}
                      >
                        Code à transmettre au transporteur
                      </p>
                      <p style={{ margin: 0 }}>
                        <OTPInput
                          inputStyle={{
                            fontFamily: "montserrat-Bold",
                            fontSize: screen_1024 ? "22px" : "18px",
                            color: "#000",
                            border: "none",
                            background: "#F4F3F6",
                            borderRadius: "12px",
                            padding: "16px",
                          }}
                          inputType="number"
                          value={state?.product_details?.ship_pickup_otp}
                          onChange={() => {}}
                          numInputs={4}
                          renderSeparator={
                            <span style={{ padding: "5px" }}></span>
                          }
                          renderInput={(props) => <input {...props} readOnly />}
                        />
                      </p>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingTop: "80px",
                        }}
                      >
                        <p
                          style={{
                            color: "#4B4A61",
                            fontSize: 14,
                            fontFamily: "montserrat-Regular",
                          }}
                        >
                          {state?.product_details?.payment_log &&
                            moment(
                              `${state?.product_details?.payment_log?.[0]?.created_at}`.endsWith(
                                "Z"
                              )
                                ? state?.product_details?.payment_log?.[0]
                                    ?.created_at
                                : state?.product_details?.payment_log?.[0]
                                    ?.created_at + "Z"
                            ).format("DD/MM/YYYY HH:mm")}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

              {(state?.product_details?.ship_status_level === 4 ||
                state?.product_details?.ship_status_level === 5) &&
                state?.product_details?.payment_status === "Paid" &&
                state?.product_details?.user_details?.id === user?.id &&
                state?.product_details?.ship_deliver_otp && (
                  <div
                    className="bg-image"
                    style={{
                      width: "100%",
                      height: screen_1024 ? "220px" : "193px",
                      borderRadius: "16px",
                      justifyContent: "center",
                          display:(announcement_details.receiver_id === state.product_details?.acc_id )
                          ? "flex"
                          : "none",
                        
                      // background: defaultLabelColors.main_orange,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        paddingTop: screen_1024 ? "30px" : "15px",
                      }}
                    >
                      <p
                        style={{
                          color: "#fff",
                          fontSize: screen_1024 ? "20px" : "14px",
                          fontFamily: "montserrat-Bold",
                          margin: 0,
                        }}
                      >
                        Votre colis est en route !{" "}
                      </p>

                      <p
                        style={{
                          fontFamily: "montserrat-SemiBold",
                          color: "#fff",
                          fontSize: screen_1024 ? 18 : 12,
                          textAlign: "center",
                        }}
                      >
                        Destinataire : {screen_1024 ? " " : <br />} Code à
                        transmettre au transporteur{" "}
                      </p>
                      <p style={{ margin: 0 }}>
                        <OTPInput
                          inputStyle={{
                            fontFamily: "montserrat-Bold",
                            fontSize: screen_1024 ? "22px" : "18px",
                            color: "#000",
                            border: "none",
                            background: "#F4F3F6",
                            borderRadius: "12px",
                            padding: "16px",
                          }}
                          inputType="number"
                          value={state?.product_details?.ship_deliver_otp}
                          onChange={() => {}}
                          numInputs={4}
                          renderSeparator={
                            <span style={{ padding: "5px" }}></span>
                          }
                          renderInput={(props) => <input {...props} readOnly />}
                        />
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          color: "#fff",
                          fontSize: screen_1024 ? "unset" : "12px",
                          textAlign: "center",
                        }}
                      >
                        Le code a été transmis à {screen_1024 ? " " : <br />}
                        <span
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            textAlign: "center",
                          }}
                        >
                          {state?.product_details?.recipient_name}{" "}
                          {/* {`(${state?.product_details?.recipient_phone_code} ${state?.product_details?.recipient_phone})`} */}
                          {formatPhoneNumber(
                            `${state?.product_details?.recipient_phone_code} ${state?.product_details?.recipient_phone}`
                          )}
                        </span>
                      </p>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingTop: "80px",
                        }}
                      >
                        <p
                          style={{
                            color: "#4B4A61",
                            fontSize: 14,
                            fontFamily: "montserrat-Regular",
                          }}
                        >
                          {state?.product_details?.payment_log &&
                            moment(
                              `${state?.product_details?.payment_log?.[0]?.created_at}`.endsWith(
                                "Z"
                              )
                                ? state?.product_details?.payment_log?.[0]
                                    ?.created_at
                                : state?.product_details?.payment_log?.[0]
                                    ?.created_at + "Z"
                            ).format("DD/MM/YYYY HH:mm")}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

              {`${state.product_details?.customer_id}` !== `${user?.id}` && (
                <div
                  key={`REQUESTER_ITEM_${JSON.stringify(last_nego) + 1}`}
                  style={{
                    borderRadius: 16,
                    borderWidth: 1,
                    borderColor: color_theme.card_border,
                    marginTop: "10px",
                    display: last_nego?.is_accepted ? "block" : "none",
                  }}
                >
                  <div
                    style={{
                      flexDirection: "row",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    {state?.product_details?.ship_status_level === 2 && (
                      <div
                        className="container-for-offer-card bg-image"
                        style={{ maxHeight: 144 }}
                      >
                        <div
                          className="text-for-offer-card"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            // paddingLeft:'20px',
                            paddingRight: "30px",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontSize: screen_1024 ? 20 : 14,
                                fontFamily: "montserrat-Bold",
                                lineHeight: "28px",
                                color: color_theme.white,
                              }}
                            >
                              Votre offre a été accepté !{" "}
                            </div>
                            <div
                              style={{
                                fontSize: screen_1024 ? 16 : 12,
                                fontFamily: "montserrat-Regular",
                                lineHeight: "20px",
                                color: color_theme.white,
                                // maxWidth: "600px",
                                rowGap: 5,
                              }}
                            >
                              Vous pouvez commencer à discuter
                              <br />
                              {`${state.product_details?.user_details?.cus_name} doit procéder au paiement avant`}
                              <br />
                              de passer à la prochaine étape
                            </div>
                          </div>

                          <div
                            style={{
                              fontSize: screen_1024 ? 40 : 20,
                              color: color_theme.white,
                              fontFamily: "montserrat-Bold",
                              lineHeight: "48px",
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                            className="amount-for-offer-card"
                          >
                            {" "}
                            + {currencyFormat(last_nego?.ship_price ?? 0)} €
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {`${state.product_details?.customer_id}` !== `${user?.id}` &&
                state?.product_details?.payment_status === "Paid" && (
                  <div
                    style={{
                      borderRadius: 16,
                      borderWidth: 1,
                      borderColor: color_theme.card_border,
                      marginTop: "10px",
                      display: last_nego?.is_accepted ? "block" : "none",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      {(state?.product_details?.ship_status_level === 2 ||
                        state?.product_details?.ship_status_level === 4 ||
                        state?.product_details?.ship_status_level === 5) &&
                        state?.product_details?.payment_status === "Paid" &&
                        (state?.product_details?.ship_status === "Accepted" ||
                          state?.product_details?.ship_status === "Picked" ||
                          state?.product_details?.ship_status ===
                            "Deliver") && (
                          <div
                            className="bg-image"
                            style={{
                              width: "100%",
                              // height: "250px",
                              borderRadius: "16px",
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "flex-end",
                              // background: defaultLabelColors.main_orange,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                marginTop: 10,
                              }}
                            >
                              <p
                                style={{
                                  color: "#fff",
                                  fontSize: screen_1024 ? "20px" : "14px",
                                  fontFamily: "montserrat-Bold",
                                  margin: 0,
                                }}
                              >
                                Paiement validé !{" "}
                              </p>

                              <p
                                style={{
                                  margin: 0,
                                  fontFamily: "montserrat-Regular",
                                  color: "#fff",
                                  fontSize: screen_1024 ? "unset" : "12px",
                                }}
                              >
                                Vous recevrez votre paiement une fois la
                                livraison effectuée
                              </p>

                              <p
                                style={{
                                  fontFamily: "montserrat-SemiBold",
                                  color: "#fff",
                                  fontSize: screen_1024 ? 16 : "12px",
                                  textAlign: "center",
                                  marginBottom: 5,
                                  marginTop: "8px",
                                }}
                              >
                                Veuillez demander à l’expéditeur le code de
                                retrait pour confirmer le ramassage
                              </p>
                              <p style={{ margin: 0 }}>
                                <OTPInput
                                  inputStyle={{
                                    fontFamily: "montserrat-Bold",
                                    fontSize: screen_1024 ? "22px" : "18px",
                                    color: "#000",
                                    border: "none",
                                    background: "#F4F3F6",
                                    borderRadius: "12px",
                                    padding: "16px",
                                  }}
                                  inputType="number"
                                  value={
                                    state?.product_details?.ship_status ===
                                      "Picked" ||
                                    state?.product_details?.ship_status ===
                                      "Deliver"
                                      ? state?.product_details?.ship_pickup_otp
                                      : otp
                                  }
                                  onChange={(otpValue) => {
                                    setOtp(otpValue);
                                  }}
                                  numInputs={4}
                                  renderSeparator={
                                    <span style={{ padding: "5px" }}></span>
                                  }
                                  renderInput={(props) => (
                                    <input
                                      disabled={
                                        selector?.user?.idenfy_verification ===
                                          true &&
                                        selector?.user
                                          ?.idenfy_verification_status ===
                                          "APPROVED"
                                          ? false
                                          : true
                                      }
                                      {...props}
                                    />
                                  )}
                                />
                              </p>
                              {state?.product_details?.ship_status ===
                                "Picked" ||
                              state?.product_details?.ship_status ===
                                "Deliver" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontFamily: "montserrat-SemiBold",
                                    fontSize: screen_1024 ? "16px" : "12px",
                                    padding: "12px 8px",
                                    margin: 1,
                                  }}
                                ></div>
                              ) : (
                                <>
                                  {selector?.user?.idenfy_verification ===
                                    true &&
                                  selector?.user?.idenfy_verification_status ===
                                    "APPROVED" ? (
                                    <CustomButton
                                      style={{
                                        fontFamily: "montserrat-SemiBold",
                                        marginTop: 5,
                                        marginBottom: 15,
                                      }}
                                      classesNames={
                                        otp?.length < 4
                                          ? "disable_contained_button_for_nego"
                                          : "contained_button_for_nego"
                                      }
                                      onClick={handleComplete}
                                      value={
                                        <React.Fragment>
                                          <div
                                            className="display-flex"
                                            style={{
                                              columnGap: "20px",
                                            }}
                                          >
                                            {"Confirmer"}
                                          </div>
                                        </React.Fragment>
                                      }
                                    />
                                  ) : (
                                    <>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          color: "#fff",
                                          fontFamily: "montserrat-Regular",
                                        }}
                                      >
                                        Veuillez vérifier votre compte via votre{" "}
                                        <span
                                          onClick={() => {
                                            navigate("/profile");
                                          }}
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "16px",
                                            color:
                                              defaultLabelColors.main_background_two,
                                            fontFamily: "montserrat-Bold",
                                            textDecoration: "underline",
                                          }}
                                        >
                                          profil{" "}
                                        </span>
                                        avant de recevoir une annonce
                                      </p>
                                    </>
                                  )}
                                </>
                              )}

                              <div
                                style={{
                                  display: "none",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  // paddingTop: "80px",
                                }}
                              >
                                <p
                                  style={{
                                    color: "#4B4A61",
                                    fontSize: 14,
                                    fontFamily: "montserrat-Regular",
                                  }}
                                >
                                  {state?.product_details?.payment_log &&
                                    moment(
                                      `${state?.product_details?.payment_log?.[0]?.created_at}`.endsWith(
                                        "Z"
                                      )
                                        ? state?.product_details
                                            ?.payment_log?.[0]?.created_at
                                        : state?.product_details
                                            ?.payment_log?.[0]?.created_at + "Z"
                                    ).format("DD/MM/YYYY HH:mm")}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                )}

              {`${state.product_details?.customer_id}` !== `${user?.id}` &&
                state?.product_details?.payment_status === "Paid" && (
                  <div
                    style={{
                      borderRadius: 16,
                      borderWidth: 1,
                      borderColor: color_theme.card_border,
                      display: last_nego?.is_accepted ? "block" : "none",
                    }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      {state?.product_details?.payment_status === "Paid" &&
                        (state?.product_details?.ship_status === "Picked" ||
                          state?.product_details?.ship_status === "Deliver") &&
                        state?.product_details?.ship_deliver_otp && (
                          <div
                            className="bg-image"
                            style={{
                              width: "100%",
                              borderRadius: "16px",
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "flex-end",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                paddingTop: 10,
                              }}
                            >
                              <p
                                style={{
                                  color: "#fff",
                                  fontSize: screen_1024 ? "20px" : "14px",
                                  fontFamily: "montserrat-Bold",
                                  margin: 0,
                                }}
                              >
                                Colis en route !{" "}
                              </p>

                              <p
                                style={{
                                  fontFamily: "montserrat-SemiBold",
                                  color: "#fff",
                                  fontSize: screen_1024 ? 18 : "12px",
                                  textAlign: "center",
                                  margin: 5,
                                }}
                              >
                                Demander le code au destinataire pour valider la
                                livraison{" "}
                              </p>
                              <p style={{ margin: 0 }}>
                                <OTPInput
                                  inputStyle={{
                                    fontFamily: "montserrat-Bold",
                                    fontSize: screen_1024 ? "22px" : "18px",
                                    color: "#000",
                                    border: "none",
                                    background: "#F4F3F6",
                                    borderRadius: "12px",
                                    padding: "16px",
                                  }}
                                  inputType="number"
                                  value={
                                    state?.product_details?.ship_status ===
                                    "Deliver"
                                      ? state?.product_details?.ship_deliver_otp
                                      : otp
                                  }
                                  onChange={(otpValue) => {
                                    setOtp(otpValue);
                                  }}
                                  numInputs={4}
                                  renderSeparator={
                                    <span style={{ padding: "5px" }}></span>
                                  }
                                  renderInput={(props) => <input {...props} />}
                                />
                              </p>
                              {state?.product_details?.ship_status ===
                              "Deliver" ? (
                                <div
                                  style={{
                                    background: "#fff",
                                    display: "none",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "8px",
                                    fontFamily: "montserrat-SemiBold",
                                    color: defaultLabelColors.main_orange_new,
                                    fontSize: screen_1024 ? "16px" : "12px",
                                    padding: "12px 8px",
                                    margin: 10,
                                    marginBottom: screen_1024 ? "unset" : "0px",
                                  }}
                                >
                                  Livré
                                </div>
                              ) : (
                                <>
                                  {" "}
                                  <CustomButton
                                    style={{
                                      fontFamily: "montserrat-SemiBold",
                                      marginTop: 5,
                                    }}
                                    classesNames={
                                      otp?.length < 4
                                        ? "disable_contained_button_for_nego"
                                        : "contained_button_for_nego"
                                    }
                                    onClick={handleComplete}
                                    value={
                                      <React.Fragment>
                                        <div
                                          className="display-flex"
                                          style={{
                                            columnGap: "20px",
                                          }}
                                        >
                                          {"Confirmer"}
                                        </div>
                                      </React.Fragment>
                                    }
                                  />{" "}
                                </>
                              )}

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  // paddingTop: "80px",
                                }}
                              >
                                <p
                                  style={{
                                    color: "#4B4A61",
                                    fontSize: 14,
                                    fontFamily: "montserrat-Regular",
                                  }}
                                >
                                  {state?.product_details?.payment_log &&
                                    moment(
                                      `${state?.product_details?.payment_log?.[0]?.created_at}`.endsWith(
                                        "Z"
                                      )
                                        ? state?.product_details
                                            ?.payment_log?.[0]?.created_at
                                        : state?.product_details
                                            ?.payment_log?.[0]?.created_at + "Z"
                                    ).format("DD/MM/YYYY HH:mm")}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                )}

              {state?.product_details?.ship_status === "Deliver" && (
                <div
                  className="bg-image"
                  style={{
                    width: "100%",
                    height: screen_1024 ? "170px" : "150px",
                    borderRadius: "16px",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: state?.user_feedback && "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingTop: "30px",
                    }}
                  >
                    <p
                      style={{
                        color: "#fff",
                        fontSize: screen_1024 ? "20px" : "14px",
                        fontFamily: "montserrat-Bold",
                        margin: 0,
                      }}
                    >
                      Livraison validée !{" "}
                    </p>

                    <p
                      style={{
                        margin: 0,
                        fontFamily: "montserrat-Regular",
                        color: "#fff",
                        marginTop: 5,
                        fontSize: screen_1024 ? "unset" : "12px",
                      }}
                    >
                      {Number(user?.id) ===
                      Number(state?.product_details?.user_details?.id)
                        ? `${state?.product_details?.acc_name} a remis votre colis à ${state?.product_details?.recipient_name}`
                        : `+${
                            state?.product_details?.agree_ship_price && state?.product_details?.order_amount_detail
                              ? currencyFormat(state?.product_details?.agree_ship_price-(state?.product_details?.order_amount_detail?.commission_amount+state?.product_details?.order_amount_detail?.commission_tax_amount))
                              : currencyFormat(state?.product_details?.ship_price-(state?.product_details?.order_amount_detail?.commission_amount+state?.product_details?.order_amount_detail?.commission_tax_amount))
                          } € dans votre porte monnaie Frank`}
                    </p>
                    {/* {state?.product_details?.feedback===null?"no":"yesss"} */}
                    {!state?.user_feedback && (
                      <CustomButton
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: defaultLabelColors.main_orange_new,

                          fontFamily: "montserrat-SemiBold",
                          background: color_theme.white,

                          border: "none",
                          borderRadius: "12px",
                          padding: "10px 30px 10px 30px",
                          minWidth: "200px",
                          maxWidth: "300px",
                          width: "260px",
                          marginTop: "10px",
                        }}
                        value={"🧡 Laisser un commentaire"}
                        onClick={() => setState({ feedbackDialog: true })}
                      />
                    )}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // paddingTop: "80px",
                      }}
                    >
                      <p
                        style={{
                          color: "#4B4A61",
                          fontSize: 14,
                          fontFamily: "montserrat-Regular",
                        }}
                      >
                        {state?.product_details?.payment_log &&
                          moment(
                            `${state?.product_details?.payment_log?.[0]?.created_at}`.endsWith(
                              "Z"
                            )
                              ? state?.product_details?.payment_log?.[0]
                                  ?.created_at
                              : state?.product_details?.payment_log?.[0]
                                  ?.created_at + "Z"
                          ).format("DD/MM/YYYY HH:mm")}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {chatMessages?.map((item: any, index: any) => (
            <MessageComponent
              item={item}
              key={`CHAT_COM_${index + 1}`}
              user={user}
              index={index}
              chatMessages={chatMessages}
            />
          ))}
        </div>

        {state?.product_details?.negotiations?.[
          state?.product_details?.negotiations?.length - 1
        ]?.is_accepted === null
        //  ||
        // `${state.product_details?.acc_id}` !==
        //   `${state?.product_details?.negotiations[0]?.created_by}`
          
          
          ? (
          <p
            style={{
              fontFamily: "montserrat-Regular",
              fontSize: 13,
              textAlign: "center",
              color: color_theme.black_40,
            }}
          >
            {state?.product_details?.is_sold_out ? (
              <div>Item sold out</div>
            ) : selector.lang === "fr" ? (
              `${user?.id}` === `${state.product_details?.user_details?.id}` ? (
                <div
                  style={{
                    display: "flex",
                    maxHeight: 56,
                    alignItems: "center",
                  }}
                >
                  <InputField
                    isDisable
                    input_style={{
                      background: "#f4f3f6",
                      borderRadius: "12px",
                      width: "96%",
                    }}
                    input_value={
                      `Vous ne pouvez pas échanger avec le transporteur jusqu’à ce qu’il accepte votre offre `
                    }
                  />
                  <div
                    style={{
                      borderRadius: screen_1024 ? "12px" : 100,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#E9E8EB",
                      width: "56px",
                      height: 56,
                    }}
                  >
                    <MessageSendIcon />
                  </div>
                </div>
              ) : (
                // `Vous ne pouvez pas échanger avec le transporteur jusqu’à ce qu’il accepte votre offre`
                <div
                  style={{
                    display: "flex",
                    maxHeight: 56,
                    alignItems: "center",
                  }}
                >
                  <InputField
                    isDisable
                    input_style={{
                      background: "#f4f3f6",
                      borderRadius: "12px",
                      width: "96%",
                    }}
                    input_value={
                      "Vous ne pouvez pas échanger avec l’expéditeur jusqu’à ce qu’il accepte votre offre."
                    }
                  />
                  <div
                    style={{
                      borderRadius: screen_1024 ? "12px" : 100,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#E9E8EB",
                      width: "56px",
                      height: 56,
                    }}
                  >
                    <MessageSendIcon />
                  </div>
                </div>
                // "Vous ne pouvez pas échanger avec l’expéditeur jusqu’à ce qu’il accepte votre offre."
              )
            ) : (
              `You can't reply to this conversation anymore until someone accepts or declined the request.`
            )}
          </p>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            {isTyping && (
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  zIndex: 999,
                  left: 10,
                }}
              >
                <div className="typing">
                  <div className="typing__dot"></div>
                  <div className="typing__dot"></div>
                  <div className="typing__dot"></div>
                </div>
              </div>
            )}
            <div
              style={{
                display: screen_1024 ? "flex" : "none",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="chat-img"
                style={{ width: 50, paddingBottom: 20, cursor: "pointer" }}
              >
                <input
                  type="file"
                  id="chat-img"
                  accept="image/jpeg, image/jpg, image/png"
                  onChange={async (e) => {
                    const result = e?.target?.files?.[0] ?? null;

                    if (!result) return;

                    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
                    if (!validTypes.includes(result.type)) {
                      alert("Only JPG, JPEG, and PNG images are allowed.");
                      return;
                    }

                    const image_uri = await toBase64(result);

                    setState({
                      temp_gallery: result,
                      base_image_uri: image_uri,
                      show_preview: true,
                      upload_type: "image",
                    });
                  }}
                  style={{ visibility: "hidden" }}
                />
                <ImageSendIcon />
              </label>
            </div>
            <InputField
              input_style={{
                background: "#f4f3f6",
                width: "97%",
                height: screen_1024 ? "56px" : "48px",
                borderRadius: "12px",
              }}
              input_value={message}
              onchange={(event: any) => {
                let { value } = event.target;
                if (value[0] === " ") {
                  return;
                }
                setMessage(event.target.value);
                updateTypingStatus(true); // Mark as typing
                debouncedStopTyping(); // Schedule stop typing
              }}
              onKeyDown={(event: any) => {
                if (event.code === "Enter") {
                  let { value } = event.target;
                  if (value[0] === " ") {
                    return;
                  }
                  setMessage(event.target.value);
                  updateTypingStatus(true); // Mark as typing
                  debouncedStopTyping(); // Schedule stop typing
                }
              }}
              placeHolder={"Envoyer un message"}
              // startIcon={!last_nego?.is_accepted ? "€" : <>

              //   <label htmlFor="chat-img"  >Upload</label>
              //   <input type="file" id="chat-img" onChange={async (e) => {
              //     // console.log("HEY JANNUU", e.target.files);
              //     const result = e?.target?.files?.[0] ?? null;

              //     const image_uri =await toBase64(result);
              //     console.log(image_uri);

              //     setState({
              //       temp_gallery: result,
              //       base_image_uri:image_uri,
              //       show_preview: true,
              //       upload_type: 'image'
              //     })

              //   }} style={{ visibility: "hidden" }} />
              // </>}
              input_type={last_nego?.is_accepted ? "text" : "numeric"}
            />
            <IconButton
              disabled={state?.disable_btn}
              onClick={() => {
                try {
                  if (message === "") {
                    return;
                  }
                  if (state.disable_btn) return;
                  setState({
                    disable_btn: true,
                  });
                  if (!_last_message) {
                    // handleNewMessage(null, null);
                    return;
                  }
                  if (last_nego?.is_accepted === false) {
                    handleNewMessageWithNegotiate();
                  } else {
                    handleNewMessage(null, null);
                  }
                } catch (error) {
                  console.log(error);
                }
              }}
              style={{
                background: defaultLabelColors.main_orange,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: screen_1024 ? 12 : 100,
                height: screen_1024 ? 56 : 48,
                width: screen_1024 ? 56 : 48,
              }}
            >
              <MessageSendIcon />
            </IconButton>
          </div>
        )}
      </div>

      <DraggableDialog
        maxWidth={"sm"}
        dialog_title={"Faire une offre"}
        open={state?.openOffer}
        handleClose={() => {
          setState({ openOffer: false });
        }}
        dialogBody={
          <DialogContent
            style={{
              display: "flex",
              background: "#fff",
            }}
            dividers
          >
            <Grid container spacing={spacing.spacing2}>
              <Grid xs={12} item>
                <div>
                  <div>
                    <div
                      className="card-container"
                      style={{ background: "#F4F3F6", borderRadius: "32px" }}
                    >
                      <img
                        src={
                          state?.product_details?.images?.[0] ??
                          state?.product_details?.shipment_items[0]
                            ?.prod_images?.[0] ??
                          no_image_url
                        }
                        className="card-image"
                        alt="prod-img"
                        style={{ height: "100%" }}
                      />
                      <div className="card-details" style={{ display: "flex" }}>
                        <div
                          style={{
                            fontSize: screen_1024 ? 20 : 18,
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            fontFamily: "montserrat-Bold",
                            color: defaultLabelColors.main_font,
                          }}
                        >
                          <p style={{ margin: 0, color: "#080626" }}>
                            {handleLocalize(
                              state?.product_details?.product_title
                            ) ??
                              state?.product_details?.shipment_items[0]
                                ?.prod_name ??
                              ""}
                          </p>

                          <p
                            style={{
                              fontFamily: "montserrat-Regular",
                              fontSize: 16,
                              margin: screen_1024 ? 0 : "10px 0px 0px 0px",
                              color: "#080626",
                            }}
                          >
                            Offre initial :{" "}
                            {currencyFormat(
                              Number(
                                state?.product_details?.negotiations?.[
                                  state?.product_details?.negotiations - 2
                                ]?.ship_price ??
                                  state?.product_details?.ship_price ??
                                  0
                              )
                            )}{" "}
                            €
                          </p>

                          <p
                            style={{
                              fontFamily: "montserrat-Regular",
                              fontSize: 16,
                              margin: 0,
                              color: defaultLabelColors.main_font,
                              marginTop: "5px",
                            }}
                          >
                            Nouvelle offre :{" "}
                            <span
                              style={{
                                fontFamily: "montserrat-Bold",
                                color: defaultLabelColors.main_orange_new,
                                fontSize: "24px",
                              }}
                            >
                              {currencyFormat(
                                state?.lastOffer?.ship_price ??
                                  state?.product_details?.ship_price ??
                                  0
                              )}{" "}
                              €
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className=" "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // lineHeight: "1px",
                      marginTop: "20px",
                      gap: "10px",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Bold",
                        color: "#281208",
                        fontSize: "28px",
                        textAlign: "center",
                      }}
                    >
                      {" "}
                      Insérez le montant de votre <br /> contre-offre
                    </p>

                    <div
                      className="display-flex"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        marginBottom: "80px",
                      }}
                    >
                      <input
                        type="text"
                        onChange={handleChangeForNego}
                        style={{
                          fontSize: "64px",
                          fontFamily: "montserrat-Bold",
                          width: "100%",
                          border: "none",
                          textAlign: "center",
                          color: defaultLabelColors.main_orange,
                        }}
                        value={state?.new_nego_price}
                        onKeyDown={(e) => {
                          if (e.key === "e") {
                            e.preventDefault();
                            return;
                          }
                        }}
                        placeholder="ex : 8 €"
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      gap: "10px",
                      paddingTop: "20px",
                    }}
                  >
                    <CustomButton
                      value={"Annuler"}
                      style={{
                        width: "100%",
                        background: "#fff",
                        color: "#000",
                        border: "1px solid #BCBBC4",
                        padding: "12px 24px",
                        borderRadius: "12px",
                        fontFamily: "montserrat-SemiBold",
                        fontSize: "16px",
                      }}
                      onClick={() => {
                        setState({
                          openOffer: false,
                          new_nego_price: "",
                        });
                      }}
                    />
                    <CustomButton
                      value={"Faire une contre-offre"}
                      style={{
                        width: "100%",
                        background: defaultLabelColors.main_orange,
                        color: color_theme.white,
                        border: `1px solid ${defaultLabelColors.main_orange}`,
                        padding: "12px 24px",
                        borderRadius: "12px",
                        fontFamily: "montserrat-SemiBold",
                        fontSize: "16px",
                      }}
                      disable={state?.disable_btn}
                      onClick={() => {
                        if (state.product_details?.ship_status_level === 2) {
                          alert("JOB ALEADY ACCEPTED BY ANOTHER PERSON");
                          return;
                        }

                        setState({
                          disable_btn: true,
                        });
                        handleCounterOffer();
                      }}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
        }
      />

      <DraggableDialog
        maxWidth={state?.show_stripe ? "sm" : "md"}
        open={state?.show_stripe}
        Width={"755px"}
        handleClose={() => {
          setState({ show_stripe: false });
        }}
        dialog_title={`${strings.payments}`}
        dialogBody={
          <DialogContent dividers>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                rowGap: 14,
              }}
            >
              <div
                style={{
                  border: "1px solid #E9E8EB",
                  borderRadius: "18px",
                  padding: "12px 16px",
                }}
              >
                {!state?.product_details?.promo && state?.doNotShowPromo ? (
                  <div>
                    <p
                      style={{
                        margin: "0px 0px 6px 0px",
                        fontFamily: "montserrat-Bold",
                        color: "#080626",
                        fontSize: "20px",
                      }}
                    >
                      Code promo{" "}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div style={{ width: "65%" }}>
                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: "#F4F3F6",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: 12,
                            paddingLeft: 10,
                          }}
                        >
                          <input
                            style={{
                              border: "none",
                              outline: "none",
                              fontSize: "16px",
                              width: "100%",
                              textTransform: "uppercase",
                              background: "#F4F3F6",
                            }}
                            value={state.promo_code_text}
                            onChange={(e) =>
                              setState({
                                promo_code_text: e.target.value,
                              })
                            }
                            placeholder={"Saisissez le code "}
                          />
                        </div>
                      </div>
                      <button
                        style={{
                          width: "30%",
                          marginLeft: "5%",
                          padding: "12px 24px",
                          backgroundColor: state.promo_code_text
                            ? color_theme.main_orange
                            : color_theme.disabled,
                          borderRadius: 12,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: state.promo_code_text
                            ? "pointer"
                            : "not-allowed",
                          border: "none",
                          outline: "none",
                          height: "56px",
                        }}
                        onClick={handleValidatePromo}
                        disabled={!state.promo_code_text} // Disable button when promo code is empty
                      >
                        <span
                          style={{
                            fontSize: 14,
                            fontFamily: "montserrat-SemiBold",
                            lineHeight: "18px",
                            color: state.promo_code_text
                              ? color_theme.white
                              : "#a4a4a4",
                          }}
                        >
                          Valider
                        </span>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p
                      style={{
                        margin: "7px",
                        fontFamily: "montserrat-Bold",
                        color: "#080626",
                        fontSize: "20px",
                        marginLeft: "0px",
                        marginTop: "0px",
                        marginBottom: "0px",
                      }}
                    >
                      Code promo{" "}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div style={{ width: "65%" }}>
                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: "#F4F3F6",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: 12,
                            paddingLeft: 10,
                          }}
                        >
                          <input
                            style={{
                              border: "none",
                              outline: "none",
                              fontSize: "16px",
                              width: "100%",
                              textTransform: "uppercase",
                              background: "#F4F3F6",
                            }}
                            readOnly
                            value={state?.product_details?.promo?.promo_code}
                            // onChange={(e) =>
                            //   setState({
                            //     promo_code_text: e.target.value,
                            //   })
                            // }
                            placeholder={"Saisissez le code "}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          width: "30%",
                          marginLeft: "5%",
                          padding: "12px 24px",
                          borderRadius: 12,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "none",
                          outline: "none",
                          height: "56px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 16,
                            fontFamily: "montserrat-Bold",
                            lineHeight: "18px",
                            color: defaultLabelColors.main_orange_new,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          Appliqué{" "}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2 9C2.79565 9 3.55871 9.31607 4.12132 9.87868C4.68393 10.4413 5 11.2044 5 12C5 12.7956 4.68393 13.5587 4.12132 14.1213C3.55871 14.6839 2.79565 15 2 15V17C2 17.5304 2.21071 18.0391 2.58579 18.4142C2.96086 18.7893 3.46957 19 4 19H20C20.5304 19 21.0391 18.7893 21.4142 18.4142C21.7893 18.0391 22 17.5304 22 17V15C21.2044 15 20.4413 14.6839 19.8787 14.1213C19.3161 13.5587 19 12.7956 19 12C19 11.2044 19.3161 10.4413 19.8787 9.87868C20.4413 9.31607 21.2044 9 22 9V7C22 6.46957 21.7893 5.96086 21.4142 5.58579C21.0391 5.21071 20.5304 5 20 5H4C3.46957 5 2.96086 5.21071 2.58579 5.58579C2.21071 5.96086 2 6.46957 2 7V9Z"
                              stroke="#EF6A31"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9 12L11 14L15 10"
                              stroke="#EF6A31"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {state?.product_details?.promo ? (
                <div
                  style={{
                    // border: `1px solid #E0E0E0`,
                    padding: "15px 10px",
                    // marginTop: 20,
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    rowGap: 14,
                    borderRadius: 5,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {strings?.delivery_cost}
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {numberFormatWithoutCurrency(
                        Number(
                          state?.product_details?.agree_ship_price ??
                            state?.product_details?.ship_price ??
                            0
                        )
                      )}
                      €
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {strings?.service_charges}
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        color: "#4B4A61",
                        margin: 0,
                      }}
                    >
                      {state?.product_details?.promo?.is_platform_charges ? (
                        <>
                          {" "}
                          <span
                            style={{
                              marginRight: "10px",
                              fontSize: "12px",
                              opacity: "0.7",
                              color: "red",
                            }}
                          >
                            {" "}
                            <s>
                              {currencyFormat(
                                state?.product_details?.service_charges ?? 1.99
                              )}
                            </s>
                          </span>{" "}
                          ---{" "}
                        </>
                      ) : (
                        numberFormatWithoutCurrency(
                          Number(
                            state?.product_details?.service_charges ?? 1.99
                          )
                        )
                      )}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      Sous total
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        color: "#4B4A61",
                        margin: 0,
                      }}
                    >
                      {/* {state?.product_details?.promo?.is_platform_charges
                                      ? "---"
                                      : numberFormatWithoutCurrency(
                                          Number(state?.product_details?.service_charges ?? 1.99)
                                        )} */}
                      {state?.product_details?.promo?.is_platform_charges
                        ? currencyFormat(
                            0 +
                              (state?.product_details?.agree_ship_price
                                ? state?.product_details?.agree_ship_price
                                : state?.product_details?.ship_price)
                          )
                        : currencyFormat(
                            (state?.product_details?.service_charges ?? 1.99) +
                              (state?.product_details?.agree_ship_price
                                ? state?.product_details?.agree_ship_price
                                : state?.product_details?.ship_price)
                          )}
                      €
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      Code promo:{" "}
                      <span
                        style={{
                          fontFamily: "montserrat-Medium",
                          fontSize: "14px",
                          textTransform: "uppercase",
                          color: "#000",
                        }}
                      >
                        {" "}
                        {state?.product_details?.promo?.promo_code}{" "}
                      </span>
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        color: "#4B4A61",
                        margin: 0,
                      }}
                    >
                      {/* {state?.product_details?.promo?.is_platform_charges
                                      ? "---"
                                      : numberFormatWithoutCurrency(
                                          Number(state?.product_details?.service_charges ?? 1.99)
                                        )} */}
                      -
                      {currencyFormat(
                        state?.product_details?.promo?.discount_amount
                      )}
                      €
                    </p>
                  </div>

                  <div style={{ height: "1px", background: "#E0E0E0" }}></div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {strings?.total}
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        margin: 0,
                        color: color_theme.main_orange,
                      }}
                    >
                      {state?.product_details?.promo
                        ? currencyFormat(
                            Number(
                              Number(
                                state?.product_details?.promo
                                  ?.actual_order_amount -
                                  state?.product_details?.promo?.discount_amount
                              )
                            ) +
                              Number(
                                state?.product_details?.promo
                                  ?.is_platform_charges
                                  ? 0
                                  : state?.product_details?.service_charges
                              )
                          )
                        : currencyFormat(
                            Number(
                              Number(
                                state?.product_details?.agree_ship_price ??
                                  state?.product_details?.ship_price ??
                                  0
                              ) +
                                Number(
                                  state?.product_details?.promo
                                    ?.is_platform_charges
                                    ? 0
                                    : state?.product_details?.service_charges
                                )
                            )
                          )}{" "}
                      €
                    </p>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    // border: `1px solid #E0E0E0`,
                    padding: "15px 10px",
                    // marginTop: 20,
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    rowGap: 14,
                    borderRadius: 5,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {strings?.delivery_cost}
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {" "}
                      {state?.product_details?.promo ? (
                        <span style={{ marginRight: "10px", color: "red" }}>
                          {" "}
                          <s>
                            {currencyFormat(
                              state?.product_details?.agree_ship_price
                                ? state?.product_details?.agree_ship_price
                                : state?.product_details?.ship_price
                            )}
                          </s>
                        </span>
                      ) : null}
                      {state?.product_details?.promo
                        ? currencyFormat(
                            Number(
                              (state?.product_details?.agree_ship_price ||
                                state?.product_details?.ship_price) -
                                (state?.product_details?.promo
                                  ?.discount_amount || 0)
                            )
                          )
                        : currencyFormat(
                            Number(
                              state?.product_details?.agree_ship_price ??
                                state?.product_details?.ship_price ??
                                0
                            )
                          )}
                      €
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {strings?.service_charges}
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        color: "#4B4A61",
                        margin: 0,
                      }}
                    >
                      {state?.product_details?.promo?.is_platform_charges ? (
                        <span style={{ marginRight: "10px", color: "red" }}>
                          {" "}
                          <s>{state?.product_details?.service_charges}</s>
                        </span>
                      ) : null}
                      {state?.product_details?.promo?.is_platform_charges
                        ? "0.00"
                        : currencyFormat(
                            Number(
                              state?.product_details?.service_charges ?? 1.99
                            )
                          )}
                      €
                    </p>
                  </div>

                  <div style={{ height: "1px", background: "#E0E0E0" }}></div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 14,
                        margin: 0,
                        color: "#4B4A61",
                      }}
                    >
                      {strings?.total}
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        fontSize: 16,
                        margin: 0,
                        color: color_theme.main_orange,
                      }}
                    >
                      {state?.product_details?.promo
                        ? currencyFormat(
                            Number(
                              Number(
                                state?.product_details?.promo
                                  ?.actual_order_amount -
                                  state?.product_details?.promo?.discount_amount
                              )
                            ) +
                              Number(
                                state?.product_details?.promo
                                  ?.is_platform_charges
                                  ? 0
                                  : state?.product_details?.service_charges
                              )
                          )
                        : currencyFormat(
                            Number(
                              Number(
                                state?.product_details?.agree_ship_price ??
                                  state?.product_details?.ship_price ??
                                  0
                              ) +
                                Number(
                                  state?.product_details?.promo
                                    ?.is_platform_charges
                                    ? 0
                                    : state?.product_details?.service_charges
                                )
                            )
                          )}{" "}
                      €
                    </p>
                  </div>
                </div>
              )}

              {state.options?.clientSecret ? (
                <Elements
                  stripe={stripePromise}
                  options={{
                    ...state.options,
                    theme: "flat",
                    appearance: {
                      variables: {
                        fontFamily: "montserrat-Regular, sans-serif",
                      },
                    },
                  }}
                >
                  <StripeCheckout
                    handleOtpSend={handleStripeCallBack}
                    {...state}
                    padding="0px"
                  />
                </Elements>
              ) : (
                "Unable to load payment"
              )}
            </div>
          </DialogContent>
        }
      />

      <DraggableDialog
        maxWidth={"md"}
        open={state?.openRating}
        handleClose={() => {
          setState({ openRating: false });
        }}
        Width={screen_1024 ? 755 : 619}
        dialog_title={`${"Avis"}`}
        dialogBody={
          <DialogContent dividers>
            <>
              <div
                style={{
                  fontFamily: "montserrat-Bold",
                  color: "#000",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              ></div>

              <div style={{ padding: screen_1024 ? "unset" : "0px 24px" }}>
                <span
                  style={{
                    fontSize: screen_1024 ? "64px" : "32px",
                    fontFamily: "montserrat-Bold",
                    width: "100%",
                    color: "#281208",
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: 7,
                  }}
                >
                  {` ${
                    currencyFormat(
                      Number(state?.details?.avg_rating?.toFixed(1))
                    ) ?? "0"
                  } `}
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.60428 2.41176C9.6408 2.33798 9.69722 2.27587 9.76716 2.23245C9.8371 2.18903 9.91779 2.16602 10.0001 2.16602C10.0824 2.16602 10.1631 2.18903 10.2331 2.23245C10.303 2.27587 10.3594 2.33798 10.396 2.41176L12.3209 6.31093C12.4478 6.56757 12.635 6.7896 12.8665 6.95797C13.098 7.12634 13.3669 7.23602 13.6501 7.27759L17.9551 7.90759C18.0367 7.91941 18.1133 7.95382 18.1764 8.00693C18.2394 8.06003 18.2863 8.12972 18.3118 8.2081C18.3373 8.28648 18.3403 8.37043 18.3206 8.45046C18.3009 8.53048 18.2591 8.60339 18.2001 8.66093L15.0868 11.6926C14.8815 11.8927 14.7278 12.1397 14.6391 12.4123C14.5504 12.6849 14.5293 12.975 14.5776 13.2576L15.3126 17.5409C15.327 17.6225 15.3182 17.7064 15.2872 17.7832C15.2562 17.8599 15.2042 17.9264 15.1372 17.9751C15.0702 18.0237 14.9909 18.0526 14.9083 18.0583C14.8257 18.0641 14.7432 18.0465 14.6701 18.0076L10.8218 15.9843C10.5682 15.8511 10.2861 15.7816 9.9997 15.7816C9.7133 15.7816 9.43119 15.8511 9.17762 15.9843L5.33012 18.0076C5.25706 18.0463 5.17461 18.0637 5.09216 18.0578C5.0097 18.0519 4.93055 18.0231 4.8637 17.9744C4.79684 17.9258 4.74498 17.8594 4.714 17.7828C4.68302 17.7061 4.67416 17.6223 4.68845 17.5409L5.42262 13.2584C5.47111 12.9757 5.4501 12.6854 5.3614 12.4126C5.27269 12.1398 5.11896 11.8927 4.91345 11.6926L1.80012 8.66176C1.74061 8.60429 1.69844 8.53126 1.67842 8.45099C1.65839 8.37072 1.66131 8.28644 1.68685 8.20775C1.71238 8.12906 1.75951 8.05913 1.82285 8.00591C1.88619 7.9527 1.9632 7.91834 2.04512 7.90676L6.34928 7.27759C6.63283 7.23634 6.90211 7.12681 7.13394 6.95842C7.36577 6.79002 7.5532 6.56782 7.68012 6.31093L9.60428 2.41176Z"
                      fill="black"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <p
                  style={{
                    fontFamily: "montserrat-Regular",
                    color: defaultLabelColors.main_font_grey,
                    fontSize: screen_1024 ? "16px" : "14px",
                  }}
                >
                  {state?.allRatings?.ratings2?.length ?? "0"} Avis
                </p>
              </div>

              {state?.allRatings?.ratings2?.slice(0, 4)?.map((i: any) => {
                return (
                  <div
                    style={{
                      borderTop: "1px solid #E9E8EB",
                      padding: screen_1024 ? "unset" : "0px 24px",
                    }}
                  >
                    <p>
                      <Stack spacing={1}>
                        <SimpleRating
                          size={15}
                          initialValue={i?.rating ?? 0}
                          fillIcon={<SmallStarIcon />}
                          emptyIcon={<SmallStarIconGray />}
                          readonly
                        />
                      </Stack>
                    </p>
                    <p
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          width: screen_1024 ? 60 : 52,
                          height: screen_1024 ? 60 : 52,
                          borderRadius: "50%",
                          overflow: "hidden",
                          justifyContent: "center",
                          alignItems: "center",
                          boxShadow: 3,
                          border: "1px solid #E0E0E0",
                        }}
                      >
                        <img
                          src={i?.profile_pic ?? no_profile_image}
                          alt="Profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                      <span
                        style={{
                          lineHeight: 1.5,
                          fontFamily: "montserrat-Regular",
                          color: "#BCBBC4",
                          fontSize: screen_1024 ? 16 : 14,
                        }}
                      >
                        {i?.added_by}
                        <br />

                        {moment(i?.created_at).format("MMM YY")}
                      </span>
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        color: defaultLabelColors.main_font,
                        fontSize: screen_1024 ? 16 : 14,
                      }}
                    >
                      {i?.feedback ? `“${i?.feedback}` : ""}
                    </p>
                  </div>
                );
              })}
            </>
          </DialogContent>
        }
      />

      {/* idher feedback ha */}
      <DraggableDialog
        maxWidth={"md"}
        Width={660}
        open={state?.feedbackDialog}
        handleClose={() => {
          setState({
            feedbackDialog: false,
          });
        }}
        dialog_title={"Laisser un commentaire"}
        dialogBody={
          <DialogContent style={{}}>
            <>
              <div
                style={{
                  padding: 10,
                  borderBottom: "1px solid #E9E8EB",
                  gap: 10,
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      // width: "20%",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 20,
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <Avatar
                        alt="Remy Sharp"
                        src={
                          Number(user?.id) ===
                          Number(state?.product_details?.user_details?.id)
                            ? state?.product_details?.acc_picture ??
                              no_profile_image
                            : state?.product_details?.user_details
                                ?.profile_pic ?? no_profile_image
                        }
                        // "https://t4.ftcdn.net/jpg/02/79/66/93/360_F_279669366_Lk12QalYQKMczLEa4ySjhaLtx1M2u7e6.jpg"
                        style={{ width: 60, height: 60 }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          right: 0,
                        }}
                      >
                        <VerifyIcon />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "montserrat-Bold",
                          color: "#080626",

                          fontSize: "18px",
                          fontWeight: 600,
                        }}
                      >
                        {
                          Number(user?.id) ===
                          Number(state?.product_details?.user_details?.id)
                            ? state?.product_details?.acc_name ??
                              "Customer Name not found"
                            : state?.product_details?.user_details?.cus_name ??
                              "Customer Name not found"

                          // state?.product_details?.user_details?.cus_name
                          // state?.product_details?.acc_name
                        }
                      </div>
                      <div style={{ display: "flex" }}>
                        <p
                          style={{
                            color: "#080626",
                            fontFamily: "montserrat-Bold",
                            fontSize: 22,
                            margin: 0,
                          }}
                        >
                          {/* {numberFormatWithoutCurrency(state?.avg_rating)} */}
                          {Number(user?.id) ===
                          Number(state?.product_details?.user_details?.id)
                            ? currencyFormat(
                                state?.product_details?.negotiations[0]?.cus_ratings?.toFixed(
                                  1
                                )
                              ) ?? "0"
                            : currencyFormat(
                                state?.product_details?.user_details?.cus_ratings?.toFixed(
                                  1
                                )
                              ) ?? "0"}
                          &nbsp;
                        </p>
                        <span style={{ display: "flex" }}>
                          <svg
                            width="20"
                            height="19"
                            viewBox="0 0 20 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.60404 1.91371C9.64056 1.83993 9.69697 1.77782 9.76692 1.7344C9.83686 1.69098 9.91755 1.66797 9.99987 1.66797C10.0822 1.66797 10.1629 1.69098 10.2328 1.7344C10.3028 1.77782 10.3592 1.83993 10.3957 1.91371L12.3207 5.81288C12.4475 6.06952 12.6347 6.29155 12.8662 6.45992C13.0977 6.6283 13.3666 6.73797 13.6499 6.77955L17.9549 7.40955C18.0364 7.42137 18.1131 7.45577 18.1761 7.50888C18.2391 7.56199 18.2861 7.63167 18.3116 7.71005C18.337 7.78843 18.3401 7.87239 18.3204 7.95241C18.3006 8.03243 18.2589 8.10534 18.1999 8.16288L15.0865 11.1945C14.8812 11.3946 14.7276 11.6416 14.6389 11.9142C14.5502 12.1869 14.5291 12.477 14.5774 12.7595L15.3124 17.0429C15.3268 17.1244 15.318 17.2083 15.287 17.2851C15.2559 17.3619 15.204 17.4284 15.137 17.477C15.07 17.5257 14.9907 17.5545 14.9081 17.5603C14.8255 17.566 14.743 17.5485 14.6699 17.5095L10.8215 15.4862C10.568 15.3531 10.2859 15.2835 9.99946 15.2835C9.71306 15.2835 9.43094 15.3531 9.17737 15.4862L5.32987 17.5095C5.25681 17.5482 5.17437 17.5656 5.09191 17.5598C5.00946 17.5539 4.9303 17.525 4.86345 17.4764C4.7966 17.4278 4.74473 17.3614 4.71375 17.2847C4.68277 17.2081 4.67392 17.1243 4.68821 17.0429L5.42237 12.7604C5.47087 12.4777 5.44986 12.1874 5.36115 11.9146C5.27245 11.6418 5.11871 11.3947 4.91321 11.1945L1.79987 8.16371C1.74037 8.10624 1.6982 8.03321 1.67817 7.95294C1.65815 7.87267 1.66107 7.78839 1.6866 7.70971C1.71214 7.63102 1.75926 7.56108 1.8226 7.50787C1.88594 7.45465 1.96296 7.4203 2.04487 7.40871L6.34904 6.77955C6.63259 6.7383 6.90186 6.62876 7.13369 6.46037C7.36552 6.29198 7.55296 6.06977 7.67987 5.81288L9.60404 1.91371Z"
                              fill="black"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <MuiRating
                      name="three-icons"
                      value={state?.ratingsCount}
                      max={5}
                      precision={1}
                      onChange={(event, newValue) => {
                        setState({ ratingsCount: newValue });
                      }}
                      onChangeActive={(event, newHover) => {
                        setHover(newHover);
                      }}
                      IconContainerComponent={({ value: index, ...props }) => {
                        if (hover !== -1) {
                          // When hovering
                          if (index < hover) {
                            // Stars before hovered one
                            return (
                              <span {...props}>
                                <StarIcon />
                              </span>
                            );
                          } else if (index === hover) {
                            // The hovered star
                            return (
                              <span {...props}>
                                <HoverStar />
                              </span>
                            );
                          } else {
                            // Stars after hovered one
                            return (
                              <span {...props}>
                                <StarIconGray />
                              </span>
                            );
                          }
                        } else {
                          // When not hovering — use selected value logic
                          if (state?.ratingsCount >= index) {
                            return (
                              <span {...props}>
                                <StarIcon />
                              </span>
                            );
                          } else {
                            return (
                              <span {...props}>
                                <StarIconGray />
                              </span>
                            );
                          }
                        }
                      }}
                      sx={{ fontSize: 40, gap: "5px" }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ padding: 0 }}>
                <p
                  style={{
                    // fontFamily: "Raleway-Semi-Bold",
                    // color: "#000",
                    marginBottom: 1,
                    fontFamily: "montserrat-Bold",
                    color: "#080626",

                    fontSize: "16px",
                  }}
                >
                  Écrivez votre commentaire
                </p>
                <div
                  id="yesso"
                  style={{
                    display: "flex",
                    gap: 30,
                    flexDirection: "column",
                  }}
                >
                  <TextField
                    placeholder="Exemple : Parfait ! Rapide et efficace"
                    variant="outlined"
                    fullWidth
                    type="text"
                    value={state.feedback ?? ""}
                    name="feedback"
                    onChange={onInputChange}
                    maxRows={3}
                    minRows={3}
                    multiline
                    InputProps={{
                      sx: {
                        backgroundColor: "#F4F3F6",
                        fontFamily: "montserrat-Regular",
                        border: "none",

                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "16px", // Optional: rounded corners
                      },
                    }}
                  />

                  <CustomButton
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#fff",
                      fontFamily: "montserrat-Regular",
                      background: state?.feedback ? "#ee6931" : "lightgrey",
                      border: "none",
                      borderRadius: "12px",
                      padding: "10px 40px 10px 40px",
                      width: "100%",
                    }}
                    disable={state?.feedback ? false : true}
                    onClick={handleAddFeedback}
                    value={"Envoyer"}
                  />
                </div>
              </div>
            </>
          </DialogContent>
        }
      />

      {state.show_preview && (
        <DraggableDialog
          maxWidth={"sm"}
          open={state?.show_preview}
          handleClose={() => {
            setState({ show_preview: false });
          }}
          dialog_title={`Preview`}
          dialogBody={
            <DialogContent dividers>
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <img
                    src={state.base_image_uri}
                    style={{
                      height: 200,
                      width: 200,
                      objectFit: "contain",
                    }}
                  />

                  <IconButton
                    disabled={state?.disable_btn}
                    onClick={() => {
                      handleNewMessage(null, state.temp_gallery);
                    }}
                    style={{
                      background: defaultLabelColors.main_orange,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: 12,
                      height: 56,
                      width: 56,
                    }}
                  >
                    <MessageSendIcon />
                  </IconButton>
                </div>
              </>
            </DialogContent>
          }
        />
      )}
    </>
  );
};

export default AnnouncementChat;
